import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
} from '../../../files/attachmentFilePreview.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  asyncz02dsa2nb2zt as async,
  launch1c91vkjzdi9sd as launch,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  forEachAnimated1m511890zq8f5 as forEachAnimated,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
  ButtonActionqmmxsu493eh2 as ButtonAction,
  button2ojurxuym14mn as button,
  applyActionFormatting3qxwpgmo0ne4m as applyActionFormatting,
} from '../../../../../utils/ButtonAction.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../../nav/crowpay.mjs';
import {
  LineItemState_Disputed_getInstance1ejlicwa0ud20 as LineItemState_Disputed_getInstance,
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  LineItemState_Issue_getInstancewwqrry76cukq as LineItemState_Issue_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  EscalationLevel_Issue_getInstancea8pbpo27up2o as EscalationLevel_Issue_getInstance,
  EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance,
  LineItemState_Resolving_getInstancem43rd15e543j as LineItemState_Resolving_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
  LineItemState_ResolveLater_getInstance12e6r673b4g9c as LineItemState_ResolveLater_getInstance,
  ProjectState_Locked_getInstance2lzy284wfpx83 as ProjectState_Locked_getInstance,
  LineItemState_ForceComplete_getInstance30t7ooav0u0dj as LineItemState_ForceComplete_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  setOf45ia9pnfhe90 as setOf,
  emptySetcxexqki71qfa as emptySet,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  RequestSiteVisit1o0qmklsbtvus as RequestSiteVisit,
  Credit2hxrirfggfkql as Credit,
  Remedy1wqpxp6byw9t6 as Remedy,
  Appeal_instance3s9wpeu612ekq as Appeal_instance,
  RequestResolveLater_instance1haqv4qpxez7b as RequestResolveLater_instance,
  MoreInfo_instance2thszg9d7ysff as MoreInfo_instance,
  Handled3ngpo7bepl0ux as Handled,
  KeepWorking_instance1l6z7q2tbtqni as KeepWorking_instance,
  ForceCompletemak8s8g9i3mp as ForceComplete,
  ClientResponse3rdi8ggal48xs as ClientResponse,
  get_entries2nzs7h371ziik as get_entries,
  Accept733y3zepx42g as Accept,
  ClientResolution_instance7vhdzajvvypa as ClientResolution_instance,
  DisputeType169p3tc7g9isk as DisputeType,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  get_isSignOff22izp8i5fus79 as get_isSignOff,
  Appealdu3t1bemwr4j as Appeal,
  DisputeType_LineItem_getInstanceq2lrx3mzykb as DisputeType_LineItem_getInstance,
  RemedyComplete1j0nrocri3mi3 as RemedyComplete,
  ClientResolution1kcdgkwzeikik as ClientResolution,
  MoreInfof0qn3z2grweu as MoreInfo,
} from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import {
  banners2ndq1wx79ibxx as banners,
  renderBanners2vok7sjtj8k1c as renderBanners,
  renderBanners1vh1dpq8pq90j as renderBanners_0,
} from '../../../../../utils/Banner.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  dismissableBanner3s49vuosvr23r as dismissableBanner,
  notificationBar4efejtg2792g as notificationBar,
} from '../../../../theming/banners.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1ahgushtajx2d as title,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  requiredLabel1u8ua88lul448 as requiredLabel,
  label287uhiq3m9m4z as label2,
} from '../../../label2.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_padded3m3frjnjujncx as get_padded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../../../files/fileManager.mjs';
import {
  isComplete3isyniin1qz2u as isComplete,
  displayState3v4rl6ol8mfdu as displayState,
  isFinal1ds8cwv2a0e8r as isFinal,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  mapOf2zpbbmyqk8xpf as mapOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  TimerAction_CompleteLineItem_getInstance3bxbacatbrybs as TimerAction_CompleteLineItem_getInstance,
  TimerAction_AllowLockProject_getInstance3xutugx5am7q as TimerAction_AllowLockProject_getInstance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus_0,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  firstOrNull1982767dljvdy as firstOrNull,
  toList3jhuyej2anx2q as toList,
  last1vo29oleiqj36 as last,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance_0,
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  toInstant2q17i3aluy6ks as toInstant,
} from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { atTime2v4vw3esgoteo as atTime } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  assertReactive30c64mz7ckt8m as assertReactive,
  assertNotNull3tylj1kgh6bbg as assertNotNull,
  assert1ckwbdkg35i20 as assert,
} from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  validategsg6go7eyi9d as validate,
  validatecngbak7otryq as validate_0,
  validateReactive1mjr7u7b9jd4s as validateReactive,
} from '../../../../../utils/validation.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../../../MonetaryValueInput.mjs';
import {
  zeroToNull11q39tqjxlqyg as zeroToNull,
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
  filter31kgiqs90is7g as filter,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../../../utils/utils.mjs';
import {
  ClientConcernSelectButtonx5iavwcao070 as ClientConcernSelectButton,
  StateTagSemanticqbegmxb4xh2t as StateTagSemantic,
} from '../../activity/concerns/tags.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import {
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../../../../theming/buttons.mjs';
import { contains3hkd7li7hrfjb as contains } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  Contractor1wog4uk4l8u77 as Contractor,
  Clientuccelyr89ch8 as Client,
  Dispute39kejofcwuxch as Dispute,
  DisputeState_Ongoing_getInstance2zn99spsjy3fz as DisputeState_Ongoing_getInstance,
  LineItem2rt64afaiyloc as LineItem,
  ScopeView2pjeasrtqdymw as ScopeView,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  get_notNull2xk5v9at1ay9v as get_notNull,
} from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_lineItem36mnygy89sqfj as get_lineItem,
  get_created2khbw6a16fbfp as get_created,
} from '../../../../../../../../crowpay-shared/com/crowpay/LineItemCompletionMessageFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  get_lineItem18mpd576lf2v8 as get_lineItem_0,
  get_created278y0y3t5m41w as get_created_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/CompletionMessageCommentFields.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { markAsReadUpdateOnRemovek70bbxx94h7h as markAsReadUpdateOnRemove } from '../../../../../extensions/HasReadBy.ext.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  sendConfirmationText2zujg5wbkbmsp as sendConfirmationText,
  acceptActionName1soryjzupmune as acceptActionName,
  sendActionName2meg4tvhm5rsl as sendActionName,
  acceptConfirmationText15yt66nimg6we as acceptConfirmationText,
} from '../../../../../extensions/CompletionResponse.ext.mjs';
import {
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  get_lineItem5qsvgygh297v as get_lineItem_1,
  get_state1140xg7i4ysgd as get_state,
} from '../../../../../../../../crowpay-shared/com/crowpay/DisputeFields.mjs';
import { get_itemIdfkyjzwbz0fug as get_itemId } from '../../../../../../../../crowpay-shared/com/crowpay/LineItemDisputeFields.mjs';
import { andvtrcuje7baox as and } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import {
  Submission1tz7ozccph0bt as Submission,
  TextAndFileInputDialog30838dtq38cw5 as TextAndFileInputDialog,
} from '../../../../dialogs/TextInputDialog.mjs';
import { MinorAdjustmentsDialog1v336wr96b0sx as MinorAdjustmentsDialog } from '../../../../dialogs/MinorAdjustmentsDialog.mjs';
import { get_scopeSet9qq32a9d0llm as get_scopeSet } from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { get__id3awjfwg3rsgw9 as get__id } from '../../../../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  timesx4ey3un7ihw1 as times,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  space2ppi73m2qk1br as space,
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { serializable2l0a6bc0gtxdw as serializable } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/serialization.mjs';
import { signOffHeader11hami6texki7 as signOffHeader } from '../../../signOffHeader.mjs';
import {
  GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance,
  get_outlinedfhcs63de0vzu as get_outlined,
} from '../../../../theming/appTheme.mjs';
import { RowWrapping1cfo2cqk4jxme as RowWrapping } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Column.commonHtml.mjs';
import {
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
  ActionImportance_Critical_getInstance3s0xptbpomhhd as ActionImportance_Critical_getInstance,
  ProjectView3mpzjwcpohxct as ProjectView,
} from '../../../../screens/common/ProjectView.mjs';
import {
  actionIcon360epyywhabwj as actionIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIcon2ywhhe1si52sc as timerRunningIcon,
  unreadIconWhen1430ixd91bo9h as unreadIconWhen,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../../../../theming/states.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../../expansion.mjs';
import {
  FormMessage_getInstance34lpbvoeaecrx as FormMessage_getInstance,
  NotReadyButton_getInstance12ctldyuk6wtt as NotReadyButton_getInstance,
  IssueButton_getInstance2eudvtxrfqyy3 as IssueButton_getInstance,
  DisputeButton_getInstance2kmp95ogq1c02 as DisputeButton_getInstance,
} from '../../../../theming/formThemes.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { inlineLabel3artc1yn03kdr as inlineLabel } from '../../../keyValue.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../files/renderFiles.mjs';
import {
  MutableRememberyv35kz5kmml7 as MutableRemember,
  mutableRemember1h6fyyolumj0o as mutableRemember,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../../../../screens/contractor/ContractorProject.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from '../../../../screens/client/ClientProject.mjs';
import { confirmLockProject3pubn8irheo5y as confirmLockProject } from '../../../../dialogs/ConfirmLockProjectDialog.mjs';
import { WorkItemRequestSignOffDialog3jlywf6lxbyl7 as WorkItemRequestSignOffDialog } from '../../../../dialogs/RequestSignOffDialog.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { DisputeWorkItemConfirmation3j4bsdnn01wun as DisputeWorkItemConfirmation } from '../../../../dialogs/DisputeWorkItemConfirmation.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import {
  get_lineItem1imixnvdujbj8 as get_lineItem_2,
  get_executedyhzhm61p8o8r as get_executed,
} from '../../../../../../../../crowpay-shared/com/crowpay/ProjectTimerFields.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
  HasFallback3lthr8mgiugg2 as HasFallback,
} from '../../../../screens/common/DialogWithDialog.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ResponseState_Completed_instance;
var ResponseState_Dispute_instance;
var ResponseState_FileDispute_instance;
var ResponseState_Resolving_instance;
var ResponseState_Issue_instance;
var ResponseState_RaiseIssue_instance;
var ResponseState_NotReady_instance;
var ResponseState_entriesInitialized;
function ResponseState_initEntries() {
  if (ResponseState_entriesInitialized)
    return Unit_instance;
  ResponseState_entriesInitialized = true;
  ResponseState_Completed_instance = ResponseState().ehr('Completed', 0, 'COMPLETED', null);
  ResponseState_Dispute_instance = ResponseState().ehr('Dispute', 1, 'DISPUTE', AppColors_getInstance().hfz_1.xg9_1);
  ResponseState_FileDispute_instance = ResponseState().ehr('FileDispute', 2, 'FILE A DISPUTE', AppColors_getInstance().hfz_1.xg9_1);
  ResponseState_Resolving_instance = ResponseState().ehr('Resolving', 3, 'RESOLVING', null);
  ResponseState_Issue_instance = ResponseState().ehr('Issue', 4, 'ISSUE', AppColors_getInstance().ifz_1.xg9_1);
  ResponseState_RaiseIssue_instance = ResponseState().ehr('RaiseIssue', 5, 'RAISE ISSUE', AppColors_getInstance().ifz_1.xg9_1);
  ResponseState_NotReady_instance = ResponseState().ehr('NotReady', 6, 'NOT READY', null);
}
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.fhr_1.xgb(LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().ffg_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.ghr_1 = p0;
      }
      sao($completion) {
        return this.ghr_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = requestFiles($this.hhr_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var preview = new (LocalFile())(item);
    $this.ihr_1.zgu_1.lam(new (FileData())(VOID, Signal().fak(''), preview, preview));
    var tmp$ret$0 = async($this.hhr_1, VOID, VOID, LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambda_0(preview));
    destination.v(tmp$ret$0);
  }
  var tmp_0 = awaitAll(destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambdaClass;
function LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambda() {
  if (LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($preview) {
        this.fhr_1 = $preview;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambdaClass;
}
function LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambda_0($preview) {
  var i = new (LineItemCompletionForm$ResponseForm$attachmentButton$slambda$slambda())($preview);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function actionBar($this, _this__u8e3s4, action) {
  var tmp;
  if (get_viewIsWide(_this__u8e3s4)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(false);
    view.zb8(get_AppDimensions().ig2_1);
    view.jbb(get_centered(view), $this.nhr(view));
    var tmp_0 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Space())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    view.jbb(get_centered(view), actionBar$goBackButton(view));
    var tmp_1 = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    applyReactiveActionFormatting(view_1, action);
    view.fbb(p_1, view_1);
    view.jbb(tmp_1, view_1);
    _this__u8e3s4.fbb(p, view);
    tmp = view;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_2 = _this__u8e3s4.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? _this__u8e3s4 : tmp0_elvis_lhs_2;
    _this__u8e3s4.ebb(p_2, view_2);
    view_2.xbm(false);
    view_2.zb8(get_AppDimensions().ig2_1);
    view_2.jbb(view_2.ibb(get_expanding(view_2), get_centered(view_2)), actionBar$goBackButton(view_2));
    var tmp_2 = view_2.ibb(get_expanding(view_2), get_centered(view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    applyReactiveActionFormatting(view_3, action, false);
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_2, view_3);
    _this__u8e3s4.fbb(p_2, view_2);
    tmp = view_2;
  }
  return tmp;
}
function staticBanners($this, _this__u8e3s4) {
  return renderBanners(_this__u8e3s4, banners(($this$banners) => {
    var tmp;
    if ($this.mhr_1.pgu_1) {
      var tmp_0;
      var tmp0_safe_receiver = $this.mhr_1.ogu_1;
      var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f8w();
      if (tmp_1 instanceof RequestSiteVisit()) {
        $this$banners.xfz('H-WIF-RF-RequestSiteVisit-info', "Review the contractor's suggested times below. You can optionally suggest your own meeting times or add notes about scheduling.");
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } else {
      var tmp_2;
      if ($this.mhr_1.qgu_1.c8y() && setOf([LineItemState_NotApproved_getInstance(), LineItemState_Issue_getInstance()]).t1($this.mhr_1.dgu_1.kfy())) {
        $this$banners.yfz('C-WIF-RF-NotReady-warn', "Don't resubmit until you properly evaluate the client's feedback. Resubmitting prematurely may delay progress and impact trust.");
        tmp_2 = Unit_instance;
      } else if ($this.mhr_1.qgu_1.c8y() && $this.mhr_1.dgu_1.kfy().equals(LineItemState_Disputed_getInstance())) {
        $this$banners.zfz('C-WIF-RF-Disputed-dang', "Disputes require careful consideration. Review the client's concerns thoroughly and propose a fair resolution. If not settled within 14 days, either party can lock the project. After lock, parties can still reach agreement and unlock, or proceed to independent decision.");
        tmp_2 = Unit_instance;
      }
      tmp = tmp_2;
    }
    return Unit_instance;
  }));
}
function escalationBanners($this, _this__u8e3s4) {
  var tmp = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.mhr_1.rgu_1));
  _this__u8e3s4.jbb(tmp, dismissableBanner(_this__u8e3s4, 'H-WIF-RaiseIssue-warn', LineItemCompletionForm$ResponseForm$escalationBanners$lambda));
  var tmp_0 = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => !($this$shownWhen.baj($this.mhr_1.sgu_1) == null));
  _this__u8e3s4.jbb(tmp_0, dismissableBanner(_this__u8e3s4, 'H-WIF-FileDispute-dang', ($this$dismissableBanner) => {
    var tmp = notificationBar($this$dismissableBanner, AppColors_getInstance().hfz_1);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$dismissableBanner.pc());
    var tmp0_elvis_lhs = $this$dismissableBanner.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$dismissableBanner : tmp0_elvis_lhs;
    $this$dismissableBanner.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp0_subject = $this$reactiveScope.baj($this.mhr_1.sgu_1);
      var tmp;
      switch (tmp0_subject == null ? -1 : tmp0_subject.b4_1) {
        case 0:
          tmp = 'This puts only this work item on hold. Other work items can continue. Parties work together to settle through structured options. If not settled after 14 days, either party can lock the project, requiring independent resolution for fund release.';
          break;
        case 1:
          tmp = 'This puts the entire project on hold. All work items are frozen. Parties work together to settle through structured options. If not settled after 14 days, either party can lock the project, requiring independent resolution for fund release.';
          break;
        case -1:
          tmp = '';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var tmp$ret$0 = tmp;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    $this$dismissableBanner.fbb(p, view);
    return $this$dismissableBanner.jbb(tmp, view);
  }));
}
function responseForm($this, _this__u8e3s4, messageRequired) {
  if ($this.mhr_1.qgu_1.w8y() && !isComplete($this.mhr_1.dgu_1.kfy()) && !$this.mhr_1.qgu_1.y8x() && !$this.mhr_1.qgu_1.z8x()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var $this$frame = view_0;
    reactive($this$frame, ($this$reactive) => {
      $this$frame.zb9();
      var tmp;
      if ($this$reactive.baj($this.mhr_1.ggv_1)) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = $this$frame;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(this_0.pc());
        var tmp0_elvis_lhs = this_0.cbb_1;
        var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
        this_0.ebb(p, view);
        view.xbm(true);
        title(view, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_0($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj($this.khr_1) ? 'Lock Project' : $this.mhr_1.qgu_1.a8y() ? 'Review Client Solution' : 'Propose Solution to ' + ($this.mhr_1.pgu_1 ? 'Contractor' : 'Client');
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        });
        staticBanners($this, view);
        if (!$this.mhr_1.pgu_1) {
          var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj($this.khr_1));
          view.jbb(tmp_0, requiredLabel(view, 'Solution Type', ($this$requiredLabel) => {
            disputeResolutionSelector($this, $this$requiredLabel);
            return Unit_instance;
          }));
        }
        this_0.fbb(p, view);
        tmp = view;
      } else {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = $this$frame;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(this_1.pc());
        var tmp0_elvis_lhs_0 = this_1.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
        this_1.ebb(p_0, view_0);
        view_0.xbm(true);
        title(view_0, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_1($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$6 = $this$reactiveScope.baj($this.khr_1) ? 'Lock Project' : 'Respond to ' + ($this.mhr_1.pgu_1 ? 'Contractor' : 'Client');
            this_0.set(tmp$ret$6);
            return Unit_instance;
          });
          return Unit_instance;
        });
        staticBanners($this, view_0);
        escalateCheckbox($this.mhr_1, view_0);
        escalationBanners($this, view_0);
        var tmp_1 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(messageRequired) && !$this$shownWhen.baj($this.khr_1) && !($this.mhr_1.pgu_1 && $this.mhr_1.qgu_1.u8y() && !$this$shownWhen.baj($this.mhr_1.rgu_1)));
        var tmp_2 = $this.mhr_1.pgu_1 ? 'Reason Type' : 'Response Type';
        view_0.jbb(tmp_1, requiredLabel(view_0, tmp_2, ($this$requiredLabel) => {
          responseSelector($this, $this$requiredLabel);
          return Unit_instance;
        }));
        this_1.fbb(p_0, view_0);
        tmp = view_0;
      }
      return tmp;
    });
    view.fbb(p_0, view_0);
    renderBanners_0(view, $this.lhr_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.xbm(true);
    view_1.zb8(get_px(0));
    // Inline function 'com.crowpay.views.components.requiredField' call
    var required = ($this$requiredField) => $this$requiredField.baj(messageRequired);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.xbm(true);
    view_2.zb8(get_AppDimensions().ng2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.xbm(false);
    view_3.zb8(get_AppDimensions().pg2_1);
    var tmp = get_centered(view_3);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (TextView())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl_2(view_4);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_2(view_4));
    reactiveScope(view_4, ($this$reactiveScope) => {
      var tmp;
      if ($this$reactiveScope.baj($this.khr_1)) {
        tmp = 'Explain decision to lock project';
      } else {
        if ($this$reactiveScope.baj($this.mhr_1.ggv_1)) {
          tmp = 'Explain Resolution';
        } else {
          var tmp_0;
          var tmp_1;
          if ($this.mhr_1.pgu_1) {
            var tmp_2 = $this.mhr_1.qgu_1.p8y();
            tmp_1 = tmp_2 instanceof RequestSiteVisit();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = !$this$reactiveScope.baj($this.mhr_1.rgu_1);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp = 'Provide times or information to help schedule';
          } else {
            tmp = 'Explain your decision or update for this work item';
          }
        }
      }
      var tmp$ret$15 = tmp;
      this_0.set(tmp$ret$15);
      return Unit_instance;
    });
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp, view_4);
    view_3.jbb(view_3.ibb(shownWhen(view_3, VOID, required), colored(view_3, AppColors_getInstance().hfz_1.xg9_1)), bodyBold(view_3, '*'));
    view_2.fbb(p_3, view_3);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_2 = view_2.hbb(FieldSemantic_getInstance());
    var tmp_3 = sizeConstraints(view_2, VOID, VOID, get_rem(10));
    // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextArea())(view_2.pc());
    var tmp0_elvis_lhs_5 = view_2.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
    view_2.ebb(p_5, view_5);
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextArea$_get_hint_$ref_niayv7(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('hint', 0, tmp_4, tmp_5, TextArea$_set_hint_$ref_apenef(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp;
      if ($this.mhr_1.pgu_1) {
        var tmp_0;
        var tmp_1;
        var tmp_2 = $this.mhr_1.qgu_1.p8y();
        if (tmp_2 instanceof RequestSiteVisit()) {
          tmp_1 = !$this$reactiveScope.baj($this.mhr_1.rgu_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = "Suggest some times you are available to meet and/or things to make the meeting a success.  Attach pictures of the areas of concern if you haven't already.";
        } else {
          tmp_0 = 'Clearly explain so concerns can be addressed.';
        }
        tmp = tmp_0;
      } else {
        tmp = 'Clearly explain your position or how concerns can be addressed.';
      }
      var prompt = tmp;
      var tmp$ret$27 = prompt + ($this$reactiveScope.baj(messageRequired) ? ' Min. ' + $this.mhr_1.agv_1 + ' characters.' : '');
      this_1.set(tmp$ret$27);
      return Unit_instance;
    });
    view_5.xah(view_5.qcl_1, $this.mhr_1.bgv_1);
    view_2.fbb(p_5, view_5);
    var tmp$ret$32 = view_2.jbb(tmp_3, view_5);
    view_2.jbb(tmp_2, tmp$ret$32);
    view_2.jbb(view_2.hbb(SubtextSemantic_getInstance()), errorText(view_2));
    view_1.fbb(p_2, view_2);
    var tmp_6 = get_atEnd(view_1);
    var tmp_7 = view_1.ibb(tmp_6, shownWhen(view_1, VOID, ($this$shownWhen) => $this$shownWhen.baj(messageRequired)));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_6 = view_1.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
    view_1.ebb(p_6, view_6);
    view_6.jba(view_6.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_8 = KMutableProperty0();
    var tmp_9 = TextView$_get_content_$ref_4pzcwl_3(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_3(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var remaining = $this.mhr_1.agv_1 - $this$reactiveScope.baj($this.mhr_1.bgv_1).length | 0;
      var tmp$ret$38 = remaining <= 0 ? '' : '(' + remaining + ') more characters required';
      this_2.set(tmp$ret$38);
      return Unit_instance;
    });
    view_1.fbb(p_6, view_6);
    view_1.jbb(tmp_7, view_6);
    view.fbb(p_1, view_1);
    var tmp_10 = shownWhen(view, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj($this.mhr_1.zgu_1).i1();
    });
    view.jbb(tmp_10, label2(view, 'Attachments', VOID, ($this$label2) => fileCarousel($this$label2, $this.mhr_1.zgu_1)));
    _this__u8e3s4.fbb(p, view);
  }
}
function disputeResolutionSelector($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Select())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_0 = listOf(null);
  var tmp_1 = new (Credit())(Companion_instance.p91(0n));
  var tmp_2 = new (Remedy())();
  // Inline function 'kotlin.takeIf' call
  var tmp_3;
  if (!$this.mhr_1.qgu_1.z8w()) {
    tmp_3 = Appeal_instance;
  } else {
    tmp_3 = null;
  }
  var tmp_4 = tmp_3;
  // Inline function 'kotlin.takeIf' call
  var tmp_5;
  if ($this.mhr_1.qgu_1.k8y()) {
    tmp_5 = RequestResolveLater_instance;
  } else {
    tmp_5 = null;
  }
  var tmp_6 = tmp_5;
  // Inline function 'kotlin.takeIf' call
  var this_0 = new (RequestSiteVisit())();
  var tmp_7;
  if (!$this.mhr_1.qgu_1.z8w()) {
    tmp_7 = this_0;
  } else {
    tmp_7 = null;
  }
  var tmp$ret$6 = tmp_7;
  var tmp_8 = _Constant___init__impl__v45mub(plus_0(tmp_0, listOfNotNull([tmp_1, tmp_2, tmp_4, tmp_6, tmp$ret$6])));
  view_0.mcf($this.mhr_1.vgu_1, new (Constant())(tmp_8), (it) => {
    var tmp1_elvis_lhs = it == null ? null : it.a8z($this.mhr_1.qgu_1.o8x_1);
    return tmp1_elvis_lhs == null ? 'Select Solution' : tmp1_elvis_lhs;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  var tmp_9 = shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.baj($this.mhr_1.vgu_1);
    return tmp instanceof Remedy();
  });
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Due Date';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(get_AppDimensions().pg2_1);
  view_2.jbb(get_centered(view_2), bodyBold(view_2, label));
  view_2.jbb(colored(view_2, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_2, '*'));
  view_1.fbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_10 = view_1.hbb(FieldSemantic_getInstance());
  var zone = Companion_getInstance_0().q27();
  // Inline function 'com.lightningkite.now' call
  var now = get_default(Companion_instance_0).d1m();
  var tmp_11 = LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda;
  var tmp_12 = $this.mhr_1.vgu_1.bak(tmp_11, LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_0);
  var tmp_13 = LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_1;
  var tmp_14 = tmp_12.bak(tmp_13, LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_2);
  var tmp_15 = (it) => {
    var tmp1_safe_receiver = it == null ? null : toLocalDateTime(it, zone);
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v1w();
  };
  var due = tmp_14.tak(tmp_15, (it) => {
    var tmp1_safe_receiver = it == null ? null : atTime(it, 23, 59);
    return tmp1_safe_receiver == null ? null : toInstant(tmp1_safe_receiver, zone);
  });
  assertReactive(due, 'Must be greater than now', VOID, ($this$assertReactive, it) => {
    var tmp = $this$assertReactive.baj($this.mhr_1.vgu_1);
    var tmp0_safe_receiver = tmp instanceof Remedy() ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = tmp0_safe_receiver.h8z_1.y26(now) >= 0;
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  });
  var tmp_16 = get_compact(view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$18 = view_1.hbb(FieldSemantic_getInstance());
  var tmp_17 = view_1.ibb(view_1.ibb(tmp_16, tmp$ret$18), validate(view_1, due));
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (LocalDateField())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  view_3.xah(view_3.lby_1, due);
  view_1.fbb(p_3, view_3);
  var tmp$ret$22 = view_1.jbb(tmp_17, view_3);
  view_1.jbb(tmp_10, tmp$ret$22);
  view.fbb(p_1, view_1);
  view.jbb(tmp_9, view_1);
  var tmp_18 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.let' call
    var it = $this$shownWhen.baj($this.mhr_1.vgu_1);
    var tmp;
    if (it instanceof Credit()) {
      tmp = true;
    } else {
      tmp = it instanceof Remedy();
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.ebb(p_4, view_4);
  view_4.xbm(true);
  view_4.zb8(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(false);
  view_5.zb8(get_AppDimensions().pg2_1);
  var tmp_19 = get_centered(view_5);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_20 = KMutableProperty0();
  var tmp_21 = TextView$_get_content_$ref_4pzcwl_4(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb_4(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp;
    var tmp_0 = $this$reactiveScope.baj($this.mhr_1.vgu_1);
    if (tmp_0 instanceof Remedy()) {
      tmp = 'Credit (Optional)';
    } else {
      tmp = 'Credit';
    }
    var tmp$ret$30 = tmp;
    this_1.set(tmp$ret$30);
    return Unit_instance;
  });
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_19, view_6);
  view_5.jbb(view_5.ibb(shownWhen(view_5, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.baj($this.mhr_1.vgu_1);
    return tmp instanceof Credit();
  }), colored(view_5, AppColors_getInstance().hfz_1.xg9_1)), bodyBold(view_5, '*'));
  view_4.fbb(p_5, view_5);
  var tmp_22 = get_compact(view_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$41 = view_4.hbb(FieldSemantic_getInstance());
  var tmp_23 = view_4.ibb(view_4.ibb(tmp_22, tmp$ret$41), validate_0(view_4, $this.mhr_1.ygu_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_7 = view_4.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
  view_4.ebb(p_7, view_7);
  view_7.xbm(false);
  var tmp_24 = view_7.ibb(get_centered(view_7), get_compact(view_7));
  // Inline function 'com.crowpay.views.components.monetaryValueInput' call
  // Inline function 'kotlin.also' call
  var this_2 = new (MonetaryValueInput())(view_7);
  this_2.bga(Companion_instance.o62(2147483647));
  view_7.xah(this_2.gg9_1, zeroToNull($this.mhr_1.xgu_1));
  this_2.tcl('Max ' + MonetaryValue__toString_impl_xslc77($this.mhr_1.wgu_1));
  var tmp$ret$44 = this_2.jg9_1;
  view_7.jbb(tmp_24, tmp$ret$44);
  view_4.fbb(p_7, view_7);
  view_4.jbb(tmp_23, view_7);
  view.fbb(p_4, view_4);
  view.jbb(tmp_18, view_4);
  _this__u8e3s4.fbb(p, view);
}
function responseSelector($this, _this__u8e3s4) {
  if ($this.mhr_1.pgu_1) {
    var tmp = LineItemCompletionForm$ResponseForm$responseSelector$lambda;
    var reasons = $this.mhr_1.vgu_1.tak(tmp, LineItemCompletionForm$ResponseForm$responseSelector$lambda_0);
    assertReactive(reasons, 'You must have at least one reason selected', VOID, ($this$assertReactive, it) => {
      var tmp;
      var tmp_0;
      var tmp_1 = $this$assertReactive.baj($this.mhr_1.vgu_1);
      if (tmp_1 instanceof ClientResponse()) {
        tmp_0 = !($this.mhr_1.qgu_1.u8y() && !$this$assertReactive.baj($this.mhr_1.rgu_1));
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !it.i1();
      } else {
        tmp = true;
      }
      return tmp;
    });
    var tmp_0 = get_scrollingHorizontally(_this__u8e3s4);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$1 = _this__u8e3s4.hbb(FieldSemantic_getInstance());
    var tmp_1 = _this__u8e3s4.ibb(tmp_0, tmp$ret$1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(false);
    var _iterator__ex2g4s = get_entries().m1();
    while (_iterator__ex2g4s.n1()) {
      var concernType = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.let' call
      var it = ClientConcernSelectButton().ygv(concernType);
      var tmp$ret$3 = get_viewIsNarrow(view) ? it.ybe(CompactSemantic_getInstance()) : it;
      var tmp_2 = view.hbb(tmp$ret$3);
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (ToggleButton())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      if (get_viewIsNarrow(view_0))
        view_0.jbb(get_centered(view_0), body(view_0, concernType.g90()));
      else
        specCenteredText(view_0, concernType.g90());
      view_0.xah(view_0.ncq_1, contains(reasons, concernType));
      view.fbb(p_0, view_0);
      view.jbb(tmp_2, view_0);
    }
    _this__u8e3s4.fbb(p, view);
    _this__u8e3s4.jbb(tmp_1, view);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
    _this__u8e3s4.ebb(p_1, view_1);
    view_1.xbm(true);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_3 = view_1.hbb(FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Select())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    var tmp_4 = _Constant___init__impl__v45mub(plus_0(listOf(null), listOfNotNull([$this.mhr_1.qgu_1.d8y() ? MoreInfo_instance : null, new (Handled())(null), KeepWorking_instance, new (ForceComplete())(null), new (RequestSiteVisit())(), $this.mhr_1.qgu_1.k8y() ? RequestResolveLater_instance : null])));
    view_2.mcf($this.mhr_1.vgu_1, new (Constant())(tmp_4), (it) => {
      var tmp1_elvis_lhs = it == null ? null : it.a8z($this.mhr_1.qgu_1.o8x_1);
      return tmp1_elvis_lhs == null ? 'Select a Response' : tmp1_elvis_lhs;
    });
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_3, view_2);
    var tmp_5 = shownWhen(view_1, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.let' call
      var it = $this$shownWhen.baj($this.mhr_1.vgu_1);
      var tmp;
      if (it instanceof Handled()) {
        tmp = true;
      } else {
        tmp = it instanceof ForceComplete();
      }
      return tmp;
    });
    // Inline function 'com.crowpay.views.components.field2' call
    var label = 'Credit (Optional)';
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    view_3.xbm(true);
    view_3.zb8(get_AppDimensions().ng2_1);
    bodyBold(view_3, label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_6 = view_3.hbb(FieldSemantic_getInstance());
    var tmp_7 = view_3.ibb(get_compact(view_3), validate_0(view_3, $this.mhr_1.ygu_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(false);
    var tmp_8 = view_4.ibb(get_centered(view_4), get_compact(view_4));
    // Inline function 'com.crowpay.views.components.monetaryValueInput' call
    // Inline function 'kotlin.also' call
    var this_0 = new (MonetaryValueInput())(view_4);
    this_0.bga(Companion_instance.o62(2147483647));
    view_4.xah(this_0.gg9_1, zeroToNull($this.mhr_1.xgu_1));
    this_0.tcl('Max ' + MonetaryValue__toString_impl_xslc77($this.mhr_1.wgu_1));
    var tmp$ret$20 = this_0.jg9_1;
    view_4.jbb(tmp_8, tmp$ret$20);
    view_3.fbb(p_4, view_4);
    var tmp$ret$25 = view_3.jbb(tmp_7, view_4);
    view_3.jbb(tmp_6, tmp$ret$25);
    view_3.jbb(view_3.hbb(SubtextSemantic_getInstance()), errorText(view_3));
    view_1.fbb(p_3, view_3);
    view_1.jbb(tmp_5, view_3);
    _this__u8e3s4.fbb(p_1, view_1);
  }
}
function actionBar$goBackButton(_this__u8e3s4) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (get_viewIsWide(view))
    specCenteredText(view, 'Go Back');
  else
    view.jbb(get_centered(view), body(view, 'Go Back'));
  onClick(view, VOID, VOID, LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambda_0());
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var LineItemCompletionForm$ResponseForm$render$slambdaClass;
function LineItemCompletionForm$ResponseForm$render$slambda() {
  if (LineItemCompletionForm$ResponseForm$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$ResponseForm$render$slambdaClass = $;
  }
  return LineItemCompletionForm$ResponseForm$render$slambdaClass;
}
function LineItemCompletionForm$ResponseForm$render$slambda_0() {
  var i = new (LineItemCompletionForm$ResponseForm$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$ResponseForm$render$lambda(it) {
  return !(it.bg1_1 == null);
}
var LineItemCompletionForm$ResponseForm$attachmentButton$slambdaClass;
function LineItemCompletionForm$ResponseForm$attachmentButton$slambda() {
  if (LineItemCompletionForm$ResponseForm$attachmentButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.hhr_1 = $$this$button;
        this.ihr_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$ResponseForm$attachmentButton$slambdaClass = $;
  }
  return LineItemCompletionForm$ResponseForm$attachmentButton$slambdaClass;
}
function LineItemCompletionForm$ResponseForm$attachmentButton$slambda_0($$this$button, this$0) {
  var i = new (LineItemCompletionForm$ResponseForm$attachmentButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$ResponseForm$escalationBanners$lambda($this$dismissableBanner) {
  return $this$dismissableBanner.jbb(notificationBar($this$dismissableBanner, AppColors_getInstance().ifz_1), body($this$dismissableBanner, 'This pauses the funds release timer and notifies the contractor. You can review their response and decide your next steps.'));
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextArea$_get_hint_$ref_niayv7(p0) {
  return () => p0.scl_1;
}
function TextArea$_set_hint_$ref_apenef(p0) {
  return (_this__u8e3s4) => {
    p0.tcl(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda(it) {
  return it instanceof Remedy() ? it : null;
}
function LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_0(old, r) {
  return r == null ? old : r;
}
function LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_1(it) {
  return it == null ? null : it.h8z_1;
}
function LineItemCompletionForm$ResponseForm$disputeResolutionSelector$lambda_2(o, it) {
  var tmp;
  if (it == null) {
    tmp = o;
  } else {
    tmp = o == null ? null : o.q8z(it);
  }
  return tmp;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function LineItemCompletionForm$ResponseForm$responseSelector$lambda(it) {
  var tmp0_safe_receiver = it instanceof ClientResponse() ? it : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o8w_1;
  return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
}
function LineItemCompletionForm$ResponseForm$responseSelector$lambda_0(it) {
  return new (ClientResponse())(it);
}
var LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambdaClass;
function LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambda() {
  if (LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambdaClass = $;
  }
  return LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambdaClass;
}
function LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambda_0() {
  var i = new (LineItemCompletionForm$ResponseForm$actionBar$goBackButton$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_createDialog__bkuuho($this, lineItem, project, lens, scope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp0_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp1_condition = eq(get_lineItem(it), lineItem.kf9_1);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
  var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$6);
  this_1.m4a(get_created(it_0));
  var tmp2_orderBy = this_1.o1r();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = session.cfw_1.feo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var messages = tmp_2;
  var tmp3_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(CompletionMessageComment()), arrayOf([]), false));
  var tmp$ret$13 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it_1 = new (DataClassPathSelf())(tmp$ret$13);
  var tmp4_condition = eq(get_lineItem_0(it_1), lineItem.kf9_1);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(CompletionMessageComment()), arrayOf([]), false));
  var tmp$ret$18 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$18);
  this_3.m4a(get_created_0(it_2));
  var tmp5_orderBy = this_3.o1r();
  var replies = session.efw_1.feo(new (Query())(tmp4_condition, tmp5_orderBy, VOID, tmp3_limit));
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = session.jfv_1.eeo(project.z7a_1);
  var tmp_5 = await_0(this_4, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp6_elvis_lhs = tmp_5;
  var tmp_6;
  if (tmp6_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Contractor()), null);
  } else {
    tmp_6 = tmp6_elvis_lhs;
  }
  var contractor = tmp_6;
  var tmp7_elvis_lhs = project.c7b_1;
  var tmp_7;
  if (tmp7_elvis_lhs == null) {
    throw IllegalStateException().o4('Project has no client');
  } else {
    tmp_7 = tmp7_elvis_lhs;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = session.ifv_1.eeo(tmp_7);
  var tmp_8 = await_0(this_5, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var tmp8_elvis_lhs = tmp_8;
  var tmp_9;
  if (tmp8_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Client()), null);
  } else {
    tmp_9 = tmp8_elvis_lhs;
  }
  var client = tmp_9;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_6 = session.pfw_1;
  var tmp_10 = await_0(this_6, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  var tmp9_safe_receiver = tmp_10.m88_1;
  var role = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.j8c_1;
  return new (LineItemCompletionForm())(lineItem, project, messages, replies, client, contractor, role, lens, scope);
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = markAsReadUpdateOnRemove(session.cfw_1, $this.ohr_1, $this.phr_1.fgu_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.phr_1.ggu_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsReadUpdateOnRemove(session.efw_1, $this.ohr_1, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qhr_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var r = tmp;
  var tmp_0 = JumpTo_getInstance().pg3_1;
  tmp_0.xg4(r.p5d_1, $this.rhr_1, VOID, () => {
    var tmp;
    var tmp0_safe_receiver = lastOrNull($this.shr_1.fgu_1);
    if (!r.q5d_1.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y6g_1)) {
      set_value($this.shr_1.hgv_1, true);
      tmp = Unit_instance;
    }
    set_value($this.thr_1, true);
    return Unit_instance;
  });
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp1_completionMessage = $this.uhr_1.y6g_1;
  var tmp2_project = $this.vhr_1.egu_1.x7a_1;
  var tmp3_lineItem = $this.vhr_1.dgu_1.kf9_1;
  var tmp4_clientMessage = $this.vhr_1.pgu_1;
  var tmp5_sender = session.efv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.whr_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var tmp6_message = tmp_1;
  var tmp_2 = session.efw_1.mft(new (CompletionMessageComment())(VOID, tmp1_completionMessage, tmp2_project, tmp3_lineItem, tmp5_sender, VOID, tmp4_clientMessage, tmp6_message), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.whr_1.mam(null);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = $this.xhr_1.vgu_1.gah(new (Accept())($this.yhr_1, session.ufw()), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = sendResponse($this.xhr_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  closeForm($this.xhr_1, $this.zhr_1);
  return Unit_instance;
}
var LineItemCompletionForm$acceptAction$slambda$slambdaClass;
function LineItemCompletionForm$acceptAction$slambda$slambda() {
  if (LineItemCompletionForm$acceptAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $proposal, $this_acceptAction) {
        this.xhr_1 = this$0;
        this.yhr_1 = $proposal;
        this.zhr_1 = $this_acceptAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$acceptAction$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$acceptAction$slambda$slambdaClass;
}
function LineItemCompletionForm$acceptAction$slambda$slambda_0(this$0, $proposal, $this_acceptAction) {
  var i = new (LineItemCompletionForm$acceptAction$slambda$slambda())(this$0, $proposal, $this_acceptAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  if (it) {
    var tmp = sendResponse($this.ahs_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    closeForm($this.ahs_1, $this.bhs_1);
  }
  return Unit_instance;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().ngd();
  return Unit_instance;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.ahs_1 = this$0;
        this.bhs_1 = $this_primaryResponseAction;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_0(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda())(this$0, $this_primaryResponseAction);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = sendResponse($this.chs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.chs_1, $this.dhs_1);
  return Unit_instance;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_0;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_1() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.chs_1 = this$0;
        this.dhs_1 = $this_primaryResponseAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_0;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_2(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_1())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = sendResponse($this.ehs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.ehs_1, $this.fhs_1);
  return Unit_instance;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_1;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_3() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.ehs_1 = this$0;
        this.fhs_1 = $this_primaryResponseAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_1 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_1;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_4(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_3())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = sendResponse($this.ghs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.ghs_1, $this.hhs_1);
  return Unit_instance;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_2;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_5() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.ghs_1 = this$0;
        this.hhs_1 = $this_primaryResponseAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_2 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_2;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_6(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_5())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = sendResponse($this.ihs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.ihs_1, $this.jhs_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $this$FormAction, $completion) {
  var tmp = awaitSuspending($this.khs_1.vgu_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = awaitSuspending($this.khs_1.dgv_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp1_safe_receiver = tmp_1;
    tmp_0 = sendConfirmationText(tmp0_safe_receiver, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x7t_1, $this.khs_1.qgu_1);
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp2_elvis_lhs;
  }
  var _destruct__k2r9zo = tmp_2;
  var hdr = _destruct__k2r9zo.cf();
  var msg = _destruct__k2r9zo.df();
  var c = _destruct__k2r9zo.ww();
  confirmationDialog($this.lhs_1, hdr, msg, c, VOID, VOID, VOID, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_8($this.khs_1, $this.lhs_1));
  return Unit_instance;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_3;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_7() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.ihs_1 = this$0;
        this.jhs_1 = $this_primaryResponseAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_3 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambdaClass_3;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_8(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_7())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Dispute()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$4 = and(eq(get_itemId(get_notNull(get_lineItem_1(it))), $this.mhs_1.dgu_1.kf9_1), eq(get_state(it), DisputeState_Ongoing_getInstance()));
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, 1);
  var tmp_1 = awaitSuspending(session.ffw_1.feo(tmp$ret$5), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_elvis_lhs = firstOrNull(tmp_1);
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Dispute()), null);
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var dispute = tmp_2;
  var tmp_3 = session.tfw().rff_1.sfj(dispute.k5w_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  closeForm($this.mhs_1, $this.nhs_1);
  return Unit_instance;
}
var LineItemCompletionForm$lockProjectAction$slambda$slambdaClass;
function LineItemCompletionForm$lockProjectAction$slambda$slambda() {
  if (LineItemCompletionForm$lockProjectAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_lockProjectAction) {
        this.mhs_1 = this$0;
        this.nhs_1 = $this_lockProjectAction;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$lockProjectAction$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$lockProjectAction$slambda$slambdaClass;
}
function LineItemCompletionForm$lockProjectAction$slambda$slambda_0(this$0, $this_lockProjectAction) {
  var i = new (LineItemCompletionForm$lockProjectAction$slambda$slambda())(this$0, $this_lockProjectAction);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.ohs_1 = p0;
      }
      sao($completion) {
        return this.ohs_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, $this$TextAndFileInputDialog, submission, $completion) {
  if (submission == null) {
    get_dialogStack().ngd();
    return Unit_instance;
  }
  $this.phs_1.vgu_1.mam(ClientResolution_instance);
  $this.phs_1.bgv_1.mam(submission.xh2_1);
  $this.phs_1.zgu_1.xam(submission.yh2_1);
  var tmp = sendResponse($this.phs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.phs_1, $this$TextAndFileInputDialog);
  return Unit_instance;
}
var LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass;
function LineItemCompletionForm$actionBar$lambda$slambda$slambda() {
  if (LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_remember) {
        this.qhs_1 = $this_remember;
      }
      sao($completion) {
        return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(this.qhs_1.baj(get_session()).tfw().efg_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass;
}
function LineItemCompletionForm$actionBar$lambda$slambda$slambda_0($this_remember) {
  var i = new (LineItemCompletionForm$actionBar$lambda$slambda$slambda())($this_remember);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass_0;
function LineItemCompletionForm$actionBar$lambda$slambda$slambda_1() {
  if (LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.phs_1 = this$0;
      }
      ch3($this$TextAndFileInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$TextAndFileInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.ch3(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$actionBar$lambda$slambda$slambdaClass_0;
}
function LineItemCompletionForm$actionBar$lambda$slambda$slambda_2(this$0) {
  var i = new (LineItemCompletionForm$actionBar$lambda$slambda$slambda_1())(this$0);
  var l = ($this$TextAndFileInputDialog, submission, $completion) => i.ch3($this$TextAndFileInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $this$FormAction, $completion) {
  var tmp = get_dialogStack();
  var tmp_0;
  if (!($this.rhs_1.lgu_1 == null)) {
    var tmp_1 = awaitSuspending(get_session(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    // Inline function 'com.lightningkite.lightningdb.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$1);
    var tmp$ret$3 = eq(get_scopeSet(it), $this.rhs_1.lgu_1.zhs_1);
    var tmp$ret$4 = new (Query())(tmp$ret$3, orderBy, 0, 100);
    var tmp_3 = awaitSuspending(tmp_1.mfv_1.feo(tmp$ret$4), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = awaitSuspending(get_session(), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    // Inline function 'com.lightningkite.lightningdb.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy_0 = emptyList();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_5 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$6);
    var tmp$ret$8 = eq(get__id(it_0), $this.rhs_1.lgu_1.zhs_1);
    var tmp$ret$9 = new (Query())(tmp$ret$8, orderBy_0, 0, 1);
    var tmp_6 = awaitSuspending(tmp_4.ufv_1.feo(tmp$ret$9), $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = firstOrNull(tmp_6);
    tmp_0 = MinorAdjustmentsDialog().cht(tmp_3, tmp_7, ($this$MinorAdjustmentsDialog, accepted) => {
      get_dialogStack().ngd();
      var tmp;
      if (accepted) {
        closeForm($this.rhs_1, $this$MinorAdjustmentsDialog);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  } else {
    tmp_0 = MinorAdjustmentsDialog().yhs($this.rhs_1.dgu_1.hf9_1, ($this$MinorAdjustmentsDialog, accepted) => {
      get_dialogStack().ngd();
      var tmp;
      if (accepted) {
        closeForm($this.rhs_1, $this$MinorAdjustmentsDialog);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
  tmp.xgd(tmp_0);
  return Unit_instance;
}
function LineItemCompletionForm$escalateCheckbox$o$invoke$lambda($this$to, it) {
  return it.ab1_1;
}
var LineItemCompletionForm$escalateCheckbox$slambda$slambdaClass;
function LineItemCompletionForm$escalateCheckbox$slambda$slambda() {
  if (LineItemCompletionForm$escalateCheckbox$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.dht_1 = this$0;
      }
      eht(selection, $completion) {
        this.dht_1.sgu_1.mam(selection);
        get_dialogStack().ngd();
      }
      s2(p1, $completion) {
        return this.eht((p1 == null ? true : p1 instanceof DisputeType()) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$escalateCheckbox$slambda$slambdaClass = $;
  }
  return LineItemCompletionForm$escalateCheckbox$slambda$slambdaClass;
}
function LineItemCompletionForm$escalateCheckbox$slambda$slambda_0(this$0) {
  var i = new (LineItemCompletionForm$escalateCheckbox$slambda$slambda())(this$0);
  var l = (selection, $completion) => i.eht(selection, $completion);
  l.$arity = 1;
  return l;
}
var ScopeSetInfoClass;
function ScopeSetInfo() {
  if (ScopeSetInfoClass === VOID) {
    class $ {
      constructor(id, name, price) {
        this.zhs_1 = id;
        this.aht_1 = name;
        this.bht_1 = price;
      }
      toString() {
        return 'ScopeSetInfo(id=' + this.zhs_1.toString() + ', name=' + this.aht_1 + ', price=' + MonetaryValue__toString_impl_xslc77(this.bht_1) + ')';
      }
      hashCode() {
        var result = this.zhs_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.aht_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.bht_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScopeSetInfo()))
          return false;
        if (!this.zhs_1.equals(other.zhs_1))
          return false;
        if (!(this.aht_1 === other.aht_1))
          return false;
        if (!(this.bht_1 === other.bht_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ScopeSetInfo');
    ScopeSetInfoClass = $;
  }
  return ScopeSetInfoClass;
}
function _get_outerPadding__4anaiz($this, _this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? null : get_AppDimensions().wg1_1;
}
function outerPadding($this, _this__u8e3s4) {
  var tmp0_safe_receiver = _get_outerPadding__4anaiz($this, _this__u8e3s4);
  var tmp = tmp0_safe_receiver;
  if ((tmp == null ? null : new (Dimension())(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp0_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new (Dimension())(tmp_0)).wb1_1;
    space(_this__u8e3s4, it);
  }
}
function closeForm($this, _this__u8e3s4) {
  get_dialogStack().ugg();
  if (lastOrNull(get_mainPageNavigator(_this__u8e3s4).gbn_1.f2()) === $this) {
    get_mainPageNavigator(_this__u8e3s4).rd6();
  }
}
var ResponseStateClass;
function ResponseState() {
  if (ResponseStateClass === VOID) {
    class $ extends Enum() {
      static ehr(name, ordinal, displayName, color) {
        var $this = this.c4(name, ordinal);
        $this.chr_1 = displayName;
        $this.dhr_1 = color;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseState');
    ResponseStateClass = $;
  }
  return ResponseStateClass;
}
function *_generator_sendResponse__y29akh($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().ffg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.vgu_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_safe_receiver = tmp_1;
  var tmp_2;
  if (tmp0_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_3;
    if (tmp0_safe_receiver instanceof ClientResponse()) {
      tmp_3 = tmp0_safe_receiver.g8z(VOID, $this.rgu_1.f2(), $this.sgu_1.f2());
    } else {
      if (tmp0_safe_receiver instanceof Credit()) {
        var tmp_4 = $this.xgu_1.f2();
        var tmp1_elvis_lhs = tmp_4 == null ? null : tmp_4.a5s_1;
        var tmp_5;
        var tmp_6 = tmp1_elvis_lhs;
        if ((tmp_6 == null ? null : new (MonetaryValue())(tmp_6)) == null) {
          return Unit_instance;
        } else {
          tmp_5 = tmp1_elvis_lhs;
        }
        tmp_3 = tmp0_safe_receiver.s8z(tmp_5);
      } else {
        if (tmp0_safe_receiver instanceof Remedy()) {
          var tmp_7 = $this.xgu_1.f2();
          tmp_3 = tmp0_safe_receiver.q8z(VOID, tmp_7 == null ? null : tmp_7.a5s_1);
        } else {
          if (tmp0_safe_receiver instanceof Handled()) {
            var tmp_8 = $this.xgu_1.f2();
            tmp_3 = tmp0_safe_receiver.d8z(tmp_8 == null ? null : tmp_8.a5s_1);
          } else {
            if (tmp0_safe_receiver instanceof ForceComplete()) {
              var tmp_9 = $this.xgu_1.f2();
              tmp_3 = tmp0_safe_receiver.d8z(tmp_9 == null ? null : tmp_9.a5s_1);
            } else {
              tmp_3 = tmp0_safe_receiver;
            }
          }
        }
      }
    }
    tmp_2 = serializable(tmp_3);
  }
  var tmp1_elvis_lhs_0 = tmp_2;
  var tmp_10;
  if (tmp1_elvis_lhs_0 == null) {
    return Unit_instance;
  } else {
    tmp_10 = tmp1_elvis_lhs_0;
  }
  var tmp_11 = tmp_10;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.bgv_1;
  var tmp_12 = await_1(this_2, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  var tmp_13 = tmp_12;
  var tmp_14 = resolveProjectAttachments($this.zgu_1, $completion);
  if (tmp_14 === get_COROUTINE_SUSPENDED())
    tmp_14 = yield tmp_14;
  var tmp_15 = tmp_0.ofm(new (LineItemCompletionMessage())(VOID, $this.egu_1.x7a_1, $this.dgu_1.kf9_1, session.efv_1, $this.pgu_1, tmp_11, tmp_13, tmp_14), $completion);
  if (tmp_15 === get_COROUTINE_SUSPENDED())
    tmp_15 = yield tmp_15;
  var sent = tmp_15;
  var tmp_16 = session.cfw_1.beo($completion);
  if (tmp_16 === get_COROUTINE_SUSPENDED())
    tmp_16 = yield tmp_16;
  session.cfw_1.bft(sent);
  return Unit_instance;
}
function sendResponse($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sendResponse__y29akh.bind(VOID, $this), $completion);
}
function page($this, _this__u8e3s4, renderingAsDialog) {
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var $this$col = view;
  $this$col.zb8(get_px(0));
  var tmp_0 = $this.pgu_1 ? 'SIGN-OFF REVIEW' : 'SIGN-OFF REQUEST';
  var tmp_1;
  if (renderingAsDialog) {
    tmp_1 = () => {
      closeForm($this, $this$col);
      return Unit_instance;
    };
  } else {
    tmp_1 = null;
  }
  signOffHeader($this$col, tmp_0, 'Decisions in this section may release escrow funds.', tmp_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_px(0));
  outerPadding($this, view_0);
  var tmp_2 = view_0.ibb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5)), get_expanding(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var tmp_3 = view_1.ibb(view_1.ibb(view_1.ibb(get_centered(view_1), get_expanding(view_1)), get_compact(view_1)), view_1.hbb(GroupedInformationSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.rowWrapping' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowWrapping())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(false);
  var tmp_4 = get_centered(view_3);
  var tmp_5 = get_rem_0(1.25);
  view_3.jbb(tmp_4, actionIcon(view_3, tmp_5, ($this$actionIcon) => {
    var tmp;
    if (!$this.qgu_1.c8y()) {
      tmp = null;
    } else {
      var tmp0_subject = $this.qgu_1.n8w();
      tmp = (tmp0_subject == null ? -1 : tmp0_subject.b4_1) === 2 ? ActionImportance_Critical_getInstance() : ActionImportance_Important_getInstance();
    }
    return tmp;
  }));
  view_3.jbb(view_3.ibb(get_centered(view_3), view_3.hbb(LineItemStateSemantic(displayState($this.dgu_1.kfy())))), boldSubTitle(view_3, displayState($this.dgu_1.kfy()).j9b_1));
  view_2.fbb(p_3, view_3);
  var tmp_6;
  var tmp_7;
  if ($this.ogu_1 == null) {
    tmp_7 = true;
  } else {
    var tmp_8 = $this.ogu_1.f8w();
    tmp_7 = tmp_8 instanceof RequestComplete();
  }
  if (tmp_7) {
    tmp_6 = true;
  } else {
    tmp_6 = $this.ogu_1.c6h_1;
  }
  if (!tmp_6) {
    var tmp_9 = align(view_2, Align_Start_getInstance(), Align_Center_getInstance());
    // Inline function 'com.crowpay.views.theming.subTitle' call
    var content = '[' + $this.ogu_1.f8w().a8z($this.qgu_1.o8x_1.j8x($this.ogu_1.g6h_1)) + ']';
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (TextView())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.ebb(p_4, view_4);
    view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_10 = view_4.tb5_1;
    var tmp_11;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(content) === 0) {
      tmp_11 = '\xA0';
    } else {
      tmp_11 = content;
    }
    tmp_10.fbu(tmp_11);
    view_2.fbb(p_4, view_4);
    view_2.jbb(tmp_9, view_4);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.ebb(p_5, view_5);
  view_5.xbm(false);
  view_5.jbb(get_centered(view_5), escalationIcon(view_5, $this.tgu_1, get_rem_0(1.25)));
  view_5.jbb(get_centered(view_5), timerRunningIcon(view_5, new (Constant())(_Constant___init__impl__v45mub($this.dgu_1.hf9_1)), $this.dgv_1, new (Constant())(_Constant___init__impl__v45mub($this.qgu_1)), get_rem_0(1.25)));
  view_2.fbb(p_5, view_5);
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_3, view_2);
  var tmp_12 = view_1.ibb(view_1.ibb(get_centered(view_1), sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(7))), get_compact(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_6 = view_1.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
  view_1.ebb(p_6, view_6);
  view_6.xbm(true);
  view_6.zb8(get_dp(2));
  var tmp0_safe_receiver = lastOrNull($this.fgu_1);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g6h_1;
  var tmp_13;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'com.lightningkite.now' call
    tmp_13 = get_default(Companion_instance_0).d1m();
  } else {
    tmp_13 = tmp1_elvis_lhs;
  }
  var last_0 = tmp_13;
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(SubtitleSemantic_getInstance()));
  view_7.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = format(last_0, Formats_getInstance().j8z_1);
  var tmp_14 = view_7.tb5_1;
  var tmp_15;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_15 = '\xA0';
  } else {
    tmp_15 = value;
  }
  tmp_14.fbu(tmp_15);
  view_6.fbb(p_7, view_7);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(SubtitleSemantic_getInstance()));
  view_8.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = format(last_0, Formats_getInstance().l8z_1);
  var tmp_16 = view_8.tb5_1;
  var tmp_17;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_17 = '\xA0';
  } else {
    tmp_17 = value_0;
  }
  tmp_16.fbu(tmp_17);
  view_6.fbb(p_8, view_8);
  view_1.fbb(p_6, view_6);
  view_1.jbb(tmp_12, view_6);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_2, view_1);
  outerPadding($this, view_0);
  $this$col.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Separator())($this$col.pc());
  var tmp0_elvis_lhs_9 = $this$col.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? $this$col : tmp0_elvis_lhs_9;
  $this$col.ebb(p_9, view_9);
  $this$col.fbb(p_9, view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_10 = $this$col.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? $this$col : tmp0_elvis_lhs_10;
  $this$col.ebb(p_10, view_10);
  view_10.xbm(false);
  view_10.zb8(get_px(0));
  outerPadding($this, view_10);
  var tmp_18 = get_expanding(view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.ebb(p_11, view_11);
  view_11.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (Space())(view_11.pc(), 0.15);
  var tmp0_elvis_lhs_12 = view_11.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.ebb(p_12, view_12);
  view_11.fbb(p_12, view_12);
  view_11.dba(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_11.pc());
  var tmp0_elvis_lhs_13 = view_11.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
  view_11.ebb(p_13, view_13);
  view_13.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.ebb(p_14, view_14);
  view_14.xbm(true);
  view_14.zb8(get_rem_0(0.5));
  bodyBold(view_14, !($this.lgu_1 == null) ? 'Scope Set' : 'Work Item');
  var reasons = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.baj($this.vgu_1);
    var tmp0_safe_receiver = tmp instanceof ClientResponse() ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_1;
      if (!tmp0_safe_receiver.o8w_1.i1()) {
        tmp_1 = tmp0_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o8w_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toList(tmp2_safe_receiver);
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      var tmp4_safe_receiver = $this.ugu_1;
      tmp_2 = tmp4_safe_receiver == null ? null : toList(tmp4_safe_receiver);
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp_2;
    return tmp5_elvis_lhs == null ? emptyList() : tmp5_elvis_lhs;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view_14.pc());
  var tmp0_elvis_lhs_15 = view_14.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.ebb(p_15, view_15);
  view_15.xbm(false);
  var tmp_19 = get_expanding(view_15);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (RowOrCol())(view_15.pc());
  var tmp0_elvis_lhs_16 = view_15.cbb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
  view_15.ebb(p_16, view_16);
  view_16.xbm(false);
  var tmp_20 = view_16.ibb(get_viewIsWide(view_16) ? Companion_getInstance_1() : get_expanding(view_16), get_centered(view_16));
  var tmp0_safe_receiver_0 = $this.lgu_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.aht_1;
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_0 = tmp1_elvis_lhs_0 == null ? $this.dgu_1.lf9_1 : tmp1_elvis_lhs_0;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (TextView())(view_16.pc());
  var tmp0_elvis_lhs_17 = view_16.cbb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
  view_16.ebb(p_17, view_17);
  view_17.jba(view_17.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_21 = view_17.tb5_1;
  var tmp_22;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_0) === 0) {
    tmp_22 = '\xA0';
  } else {
    tmp_22 = content_0;
  }
  tmp_21.fbu(tmp_22);
  view_16.fbb(p_17, view_17);
  view_16.jbb(tmp_20, view_17);
  if (get_viewIsWide(view_16)) {
    var tmp_23 = get_centered(view_16);
    var tmp_24 = view_16.ibb(tmp_23, shownWhen(view_16, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj(reasons).i1();
    }));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_18 = new (RowOrCol())(view_16.pc());
    var tmp0_elvis_lhs_18 = view_16.cbb_1;
    var p_18 = tmp0_elvis_lhs_18 == null ? view_16 : tmp0_elvis_lhs_18;
    view_16.ebb(p_18, view_18);
    view_18.xbm(false);
    forEachAnimated(view_18, reasons, VOID, LineItemCompletionForm$page$lambda);
    view_16.fbb(p_18, view_18);
    view_16.jbb(tmp_24, view_18);
  }
  if (get_viewIsWide(view_16)) {
    var tmp_25 = get_expanding(view_16);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_19 = new (Space())(view_16.pc());
    var tmp0_elvis_lhs_19 = view_16.cbb_1;
    var p_19 = tmp0_elvis_lhs_19 == null ? view_16 : tmp0_elvis_lhs_19;
    view_16.ebb(p_19, view_19);
    view_16.fbb(p_19, view_19);
    view_16.jbb(tmp_25, view_19);
  }
  var tmp_26 = get_centered(view_16);
  var tmp2_safe_receiver = $this.lgu_1;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bht_1;
  var tmp_27;
  var tmp_28 = tmp3_safe_receiver;
  if ((tmp_28 == null ? null : new (MonetaryValue())(tmp_28)) == null) {
    tmp_27 = null;
  } else {
    tmp_27 = MonetaryValue__toString_impl_xslc77(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_27;
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_1 = tmp4_elvis_lhs == null ? MonetaryValue__toString_impl_xslc77($this.dgu_1.v91()) : tmp4_elvis_lhs;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (TextView())(view_16.pc());
  var tmp0_elvis_lhs_20 = view_16.cbb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view_16 : tmp0_elvis_lhs_20;
  view_16.ebb(p_20, view_20);
  view_20.jba(view_20.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_29 = view_20.tb5_1;
  var tmp_30;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_1) === 0) {
    tmp_30 = '\xA0';
  } else {
    tmp_30 = content_1;
  }
  tmp_29.fbu(tmp_30);
  view_16.fbb(p_20, view_20);
  view_16.jbb(tmp_26, view_20);
  view_15.fbb(p_16, view_16);
  view_15.jbb(tmp_19, view_16);
  var tmp_31 = view_15.ibb(get_centered(view_15), get_secondaryButton(view_15));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (Button())(view_15.pc());
  var tmp0_elvis_lhs_21 = view_15.cbb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_15 : tmp0_elvis_lhs_21;
  view_15.ebb(p_21, view_21);
  specCenteredText(view_21, 'View Item');
  onClick(view_21, 'View Item', VOID, LineItemCompletionForm$page$slambda_0(view_21, $this));
  view_15.fbb(p_21, view_21);
  view_15.jbb(tmp_31, view_21);
  view_14.fbb(p_15, view_15);
  if (get_viewIsNarrow(view_14)) {
    var tmp_32 = shownWhen(view_14, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj(reasons).i1();
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_22 = new (RowOrCol())(view_14.pc());
    var tmp0_elvis_lhs_22 = view_14.cbb_1;
    var p_22 = tmp0_elvis_lhs_22 == null ? view_14 : tmp0_elvis_lhs_22;
    view_14.ebb(p_22, view_22);
    view_22.xbm(false);
    forEachAnimated(view_22, reasons, VOID, LineItemCompletionForm$page$lambda_0);
    view_14.fbb(p_22, view_22);
    view_14.jbb(tmp_32, view_22);
  }
  greySeparator(view_14);
  view_13.fbb(p_14, view_14);
  renderBanners_1($this, view_13);
  view_11.fbb(p_13, view_13);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_23 = new (RowOrCol())(view_11.pc());
  var tmp0_elvis_lhs_23 = view_11.cbb_1;
  var p_23 = tmp0_elvis_lhs_23 == null ? view_11 : tmp0_elvis_lhs_23;
  view_11.ebb(p_23, view_23);
  view_23.xbm(true);
  var tmp_33 = get_outlined(view_23);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_24 = new (Frame())(view_23.pc());
  var tmp0_elvis_lhs_24 = view_23.cbb_1;
  var p_24 = tmp0_elvis_lhs_24 == null ? view_23 : tmp0_elvis_lhs_24;
  view_23.ebb(p_24, view_24);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_25 = new (RowOrCol())(view_24.pc());
  var tmp0_elvis_lhs_25 = view_24.cbb_1;
  var p_25 = tmp0_elvis_lhs_25 == null ? view_24 : tmp0_elvis_lhs_25;
  view_24.ebb(p_25, view_25);
  view_25.xbm(true);
  view_25.zb8(get_px(0));
  leftExpandButton(view_25, $this.hgv_1, false, VOID, VOID, VOID, LineItemCompletionForm$page$lambda_1);
  var tmp_34 = shownWhen(view_25, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.hgv_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_26 = new (RowOrCol())(view_25.pc());
  var tmp0_elvis_lhs_26 = view_25.cbb_1;
  var p_26 = tmp0_elvis_lhs_26 == null ? view_25 : tmp0_elvis_lhs_26;
  view_25.ebb(p_26, view_26);
  view_26.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_27 = new (Space())(view_26.pc(), 0.0);
  var tmp0_elvis_lhs_27 = view_26.cbb_1;
  var p_27 = tmp0_elvis_lhs_27 == null ? view_26 : tmp0_elvis_lhs_27;
  view_26.ebb(p_27, view_27);
  view_26.fbb(p_27, view_27);
  previousMessages($this, view_26);
  view_25.fbb(p_26, view_26);
  view_25.jbb(tmp_34, view_26);
  view_24.fbb(p_25, view_25);
  view_23.fbb(p_24, view_24);
  view_23.jbb(tmp_33, view_24);
  var tmp_35 = get_outlined(view_23);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_28 = new (RowOrCol())(view_23.pc());
  var tmp0_elvis_lhs_28 = view_23.cbb_1;
  var p_28 = tmp0_elvis_lhs_28 == null ? view_23 : tmp0_elvis_lhs_28;
  view_23.ebb(p_28, view_28);
  view_28.xbm(true);
  boldSubTitle(view_28, 'Most Recent Response');
  renderMessage($this, view_28, last($this.fgu_1), !$this.qgu_1.c8y());
  JumpTo_getInstance().og3_1.xg4($this.dgu_1.kf9_1, view_28);
  view_23.fbb(p_28, view_28);
  view_23.jbb(tmp_35, view_28);
  view_11.fbb(p_23, view_23);
  actionBar_0($this, view_11);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_29 = new (Space())(view_11.pc(), 0.15);
  var tmp0_elvis_lhs_29 = view_11.cbb_1;
  var p_29 = tmp0_elvis_lhs_29 == null ? view_11 : tmp0_elvis_lhs_29;
  view_11.ebb(p_29, view_29);
  view_11.fbb(p_29, view_29);
  view_10.fbb(p_11, view_11);
  view_10.jbb(tmp_18, view_11);
  outerPadding($this, view_10);
  $this$col.fbb(p_10, view_10);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function renderBanners_1($this, _this__u8e3s4) {
  return renderBanners_0(_this__u8e3s4, $this.jgv_1);
}
function previousMessages($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  launch(view, VOID, VOID, LineItemCompletionForm$previousMessages$slambda_0(view, $this));
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.fgu_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    renderMessage$default($this, view, element);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderMessage($this, _this__u8e3s4, message, showReplies) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().mg2_1);
  var tmp = view.hbb(FormMessage_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_dp(0));
  var snapshot = $this.qgu_1.o8x_1.i8x(message.g6h_1);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  var tmp_0 = view_0.hbb(CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.jbb(view_1.ibb(view_1.ibb(get_centered(view_1), get_expanding(view_1)), view_1.hbb(LineItemStateSemantic(displayState(snapshot.h8x())).ybe(BoldSemantic_getInstance()))), body(view_1, displayState(snapshot.h8x()).j9b_1));
  view_1.jbb(get_centered(view_1), escalationIcon(view_1, new (Constant())(_Constant___init__impl__v45mub(snapshot.n8w()))));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  var tmp_1 = get_padded(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(false);
  view_3.jbb(get_centered(view_3), bodyBold(view_3, message.c6h_1 ? $this.hgu_1.f5c_1 : $this.igu_1.x5i_1));
  view_3.jbb(get_centered(view_3), smallBody(view_3, format(message.g6h_1, Formats_getInstance().k8z_1)));
  view_2.fbb(p_3, view_3);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2;
  if (get_isSignOff(message.f8w()) && $this.qgu_1.m8w() > 1) {
    var tmp0 = $this.qgu_1.o8x_1.x8v_1;
    var tmp$ret$9;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_3;
      if (isInterface(tmp0, Collection())) {
        tmp_3 = tmp0.i1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.g6h_1.y26(message.g6h_1) <= 0 && get_isSignOff(element.f8w())) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$9 = count;
    }
    tmp_2 = 'Sign-Off ' + tmp$ret$9;
  } else {
    tmp_2 = message.f8w().z8y(snapshot.j8x(message.g6h_1));
  }
  inlineLabel(view_4, tmp_2, message.e6h_1);
  view_2.fbb(p_4, view_4);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!message.f6h_1.i1()) {
    label2(view_2, 'Attachments', VOID, ($this$label2) => renderFiles($this$label2, new (Constant())(_Constant___init__impl__v45mub(message.f6h_1)), get_rem(5)));
  }
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_1, view_2);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  if (showReplies) {
    renderReplies($this, view, message);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderMessage$default($this, _this__u8e3s4, message, showReplies, $super) {
  showReplies = showReplies === VOID ? true : showReplies;
  return renderMessage($this, _this__u8e3s4, message, showReplies);
}
function renderReplies($this, _this__u8e3s4, message) {
  var messageReplies = filter($this.ggu_1, ($this$filter, it) => it.q5d_1.equals(message.y6g_1));
  var viewReplies = MutableRemember().rak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
    var userId = $this$MutableRemember.baj(get_session()).efv_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$MutableRemember.baj($this.ggu_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.q5d_1.equals(message.y6g_1)) {
        destination.v(element);
      }
    }
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(destination, Collection())) {
        tmp = destination.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = destination.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (!element_0.t92().t1(userId)) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  });
  var newReply = Signal().fak(null);
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  var tmp_0 = view.ibb(get_expanding(view), view.hbb(SmallBodySemantic_getInstance()));
  view.jbb(tmp_0, leftExpandButton(view, viewReplies, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
    var tmp = get_centered($this$leftExpandButton);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$leftExpandButton.pc());
    var tmp0_elvis_lhs = $this$leftExpandButton.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
    $this$leftExpandButton.ebb(p, view);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl_5(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_5(view));
    reactiveScope(view, ($this$reactiveScope) => {
      // Inline function 'kotlin.let' call
      var it = $this$reactiveScope.baj(messageReplies).p1();
      var tmp$ret$7 = it === 0 ? 'No Comments' : it === 1 ? '1 Comment' : '' + it + ' Comments';
      this_0.set(tmp$ret$7);
      return Unit_instance;
    });
    $this$leftExpandButton.fbb(p, view);
    $this$leftExpandButton.jbb(tmp, view);
    return Unit_instance;
  }));
  var tmp_1 = get_textButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Button$_get_shown_$ref_hkylj1(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, Button$_set_shown_$ref_bpvuvj(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$12 = $this$reactiveScope.baj(messageReplies).i1();
    this_0.set(tmp$ret$12);
    return Unit_instance;
  });
  smallBody(view_0, 'Comment');
  onClick(view_0, VOID, VOID, LineItemCompletionForm$renderReplies$slambda_0(viewReplies, newReply));
  view.fbb(p_0, view_0);
  view.jbb(tmp_1, view_0);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
  var tmp_4 = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj(viewReplies));
  var tmp2 = Indent_Section_getInstance().ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = get_px(0);
  var tmp_5 = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
  _this__u8e3s4.ebb(p_1, view_1);
  var tmp_6;
  var tmp_7 = null;
  if (!((tmp_7 == null ? null : new (Dimension())(tmp_7)) == null)) {
    tmp_6 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_6 = Companion_getInstance_1();
  }
  var tmp_8 = view_1.ibb(tmp_6, indented(view_1, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(true);
  view_3.zb8(times(view_3.kba().hb0_1, 1.4));
  forEachUpdating(view_3, messageReplies, VOID, ($this$forEachUpdating, reply) => {
    var tmp = get_compact($this$forEachUpdating);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.ebb(p, view);
    view.xbm(true);
    view.zb8(get_AppDimensions().pg2_1);
    launch(view, VOID, VOID, LineItemCompletionForm$renderReplies$lambda$slambda_0(reply, view, $this, viewReplies));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().mg2_1);
    get_centered(view_0);
    unreadIconWhen(view_0, ($this$unreadIconWhen) => !$this$unreadIconWhen.baj(reply).t92().t1($this$unreadIconWhen.baj(get_session()).efv_1));
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_1();
    var tmp_0 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_6(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_6(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$22 = $this$reactiveScope.baj(reply).u5d_1;
      this_0.set(tmp$ret$22);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_0, view_1);
    var tmp_3 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl_7(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_7(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$29 = format($this$reactiveScope.baj(reply).y5d_1, Formats_getInstance().k8z_1);
      this_1.set(tmp$ret$29);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_3, view_2);
    view.fbb(p_0, view_0);
    var tmp_6 = get_lightSection(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(true);
    view_4.zb8(get_px(0));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl_8(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_8(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp$ret$40 = $this$reactiveScope.baj(reply).w5d_1;
      this_2.set(tmp$ret$40);
      return Unit_instance;
    });
    view_4.fbb(p_5, view_5);
    var tmp_9 = view_4.ibb(get_atEnd(view_4), get_textButton(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Button())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    view_6.eba(get_dp(2));
    view_6.zb8(get_dp(2));
    shownDefaultFalse(view_6, ($this$shownDefaultFalse) => {
      var tmp0_safe_receiver = lastOrNull($this$shownDefaultFalse.baj(messageReplies));
      return equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p5d_1, $this$shownDefaultFalse.baj(reply).p5d_1);
    });
    smallBody(view_6, 'Reply');
    onClick(view_6, VOID, VOID, LineItemCompletionForm$renderReplies$lambda$slambda_2(newReply));
    view_4.fbb(p_6, view_6);
    view_4.jbb(tmp_9, view_6);
    view_3.fbb(p_4, view_4);
    view.fbb(p_3, view_3);
    view.jbb(tmp_6, view_3);
    $this$forEachUpdating.fbb(p, view);
    $this$forEachUpdating.jbb(tmp, view);
    return Unit_instance;
  });
  view_2.fbb(p_3, view_3);
  var tmp_9 = shownWhen(view_2, VOID, ($this$shownWhen) => !($this$shownWhen.baj(newReply) == null));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view_4.pc(), 0.1);
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_4.fbb(p_5, view_5);
  // Inline function 'com.crowpay.views.components.field2' call
  var label = 'New Comment';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.ebb(p_6, view_6);
  view_6.xbm(true);
  view_6.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_6, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_10 = view_6.hbb(FieldSemantic_getInstance());
  var tmp_11 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(8));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextArea())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  var tmp_12 = LineItemCompletionForm$renderReplies$lambda;
  view_7.xah(view_7.qcl_1, newReply.tak(tmp_12, LineItemCompletionForm$renderReplies$lambda_0));
  view_6.fbb(p_7, view_7);
  var tmp$ret$72 = view_6.jbb(tmp_11, view_7);
  view_6.jbb(tmp_10, tmp$ret$72);
  view_6.jbb(view_6.hbb(SubtextSemantic_getInstance()), errorText(view_6));
  view_4.fbb(p_6, view_6);
  var tmp_13 = get_atEnd(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_8 = view_4.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
  view_4.ebb(p_8, view_8);
  view_8.xbm(false);
  var tmp_14 = get_secondaryButton(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Button())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  specCenteredText(view_9, 'Discard');
  onClick(view_9, VOID, VOID, LineItemCompletionForm$renderReplies$slambda_2(newReply));
  view_8.fbb(p_9, view_9);
  view_8.jbb(tmp_14, view_9);
  var tmp_15 = get_primaryButton(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Button())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  specCenteredText(view_10, 'Send Comment');
  onClick(view_10, VOID, VOID, LineItemCompletionForm$renderReplies$slambda_4(message, $this, newReply));
  view_8.fbb(p_10, view_10);
  view_8.jbb(tmp_15, view_10);
  view_4.fbb(p_8, view_8);
  view_4.jbb(tmp_13, view_8);
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_9, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Space())(view_2.pc(), 0.25);
  var tmp0_elvis_lhs_11 = view_2.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_2 : tmp0_elvis_lhs_11;
  view_2.ebb(p_11, view_11);
  view_2.fbb(p_11, view_11);
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_8, view_2);
  _this__u8e3s4.fbb(p_1, view_1);
  var tmp$ret$102 = _this__u8e3s4.jbb(tmp_5, view_1);
  _this__u8e3s4.jbb(tmp_4, tmp$ret$102);
}
function FormAction($this, name, displayName, theme, requiresValidMessage, additionalConstraint, action) {
  var tmp;
  if (requiresValidMessage || !(additionalConstraint == null)) {
    tmp = ($this$ButtonAction) => {
      var tmp = requiresValidMessage ? $this$ButtonAction.baj($this.ngu_1.pat_1).i1() : true;
      var tmp0_safe_receiver = additionalConstraint;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        tmp_0 = tmp0_safe_receiver($this$ButtonAction);
      }
      return !!(tmp & !(tmp_0 === false));
    };
  } else {
    tmp = null;
  }
  return ButtonAction().dg1(name, theme, displayName, VOID, VOID, tmp, action);
}
function FormAction$default($this, name, displayName, theme, requiresValidMessage, additionalConstraint, action, $super) {
  displayName = displayName === VOID ? null : displayName;
  theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
  requiresValidMessage = requiresValidMessage === VOID ? true : requiresValidMessage;
  additionalConstraint = additionalConstraint === VOID ? null : additionalConstraint;
  return FormAction($this, name, displayName, theme, requiresValidMessage, additionalConstraint, action);
}
function acceptAction($this, _this__u8e3s4, proposal, theme) {
  var tmp0_name = acceptActionName(proposal, $this.qgu_1.o8x_1);
  return FormAction$default($this, tmp0_name, VOID, theme, false, VOID, LineItemCompletionForm$acceptAction$slambda_0(proposal, $this, _this__u8e3s4));
}
function acceptAction$default($this, _this__u8e3s4, proposal, theme, $super) {
  theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
  return acceptAction($this, _this__u8e3s4, proposal, theme);
}
function primaryResponseAction($this, _this__u8e3s4) {
  return remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if (isFinal($this.dgu_1.kfy())) {
      tmp = null;
    } else {
      if ($this$remember.baj($this.rgu_1)) {
        var tmp_0 = IssueButton_getInstance();
        var tmp_1 = ($this$FormAction) => $this.qgu_1.g8y() ? $this$FormAction.baj($this.rgu_1) : true;
        tmp = FormAction$default($this, 'Raise Issue', VOID, tmp_0, VOID, tmp_1, LineItemCompletionForm$primaryResponseAction$lambda$slambda_0($this, _this__u8e3s4));
      } else {
        if (!($this$remember.baj($this.sgu_1) == null)) {
          var tmp_2 = DisputeButton_getInstance();
          var tmp_3 = ($this$FormAction) => $this.qgu_1.h8y() ? !($this$FormAction.baj($this.sgu_1) == null) : true;
          tmp = FormAction$default($this, 'Submit Dispute', VOID, tmp_2, VOID, tmp_3, LineItemCompletionForm$primaryResponseAction$lambda$slambda_2(_this__u8e3s4, $this));
        } else {
          var tmp_4;
          if ($this.pgu_1) {
            var tmp0_safe_receiver = $this.ogu_1;
            tmp_4 = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f8w(), MoreInfo_instance);
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            tmp = FormAction$default($this, 'Provide Info', VOID, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda_4(_this__u8e3s4, $this));
          } else {
            var tmp_5;
            if ($this.pgu_1) {
              // Inline function 'kotlin.run' call
              var $this$run = $this.qgu_1;
              var tmp_6;
              if (!($this$run.p8y() == null) && !equals($this$run.p8y(), $this$run.q8y())) {
                var tmp_7 = $this$run.p8y();
                var tmp0_safe_receiver_0 = $this.ogu_1;
                tmp_6 = equals(tmp_7, tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.f8w());
              } else {
                tmp_6 = false;
              }
              tmp_5 = tmp_6;
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              tmp = acceptAction$default($this, _this__u8e3s4, ensureNotNull($this.qgu_1.p8y()));
            } else {
              if ($this.pgu_1 && $this.qgu_1.g8x().d4(LineItemState_Issue_getInstance()) <= 0 && $this.qgu_1.c8y() && !($this.qgu_1.e8y() || $this.qgu_1.v8w())) {
                var tmp_8 = $this.qgu_1.u8w() ? 'Resubmit Issue' : 'Mark Not Ready';
                var tmp_9 = $this.qgu_1.u8w() ? IssueButton_getInstance() : NotReadyButton_getInstance();
                tmp = FormAction$default($this, tmp_8, VOID, tmp_9, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda_6(_this__u8e3s4, $this));
              } else {
                if (!$this.pgu_1 && ($this.qgu_1.c8y() || $this.qgu_1.m8y()) && !$this.qgu_1.z8x() && !$this.qgu_1.y8x()) {
                  var tmp_10 = ($this$FormAction) => {
                    var tmp0_safe_receiver = $this$FormAction.baj($this.vgu_1);
                    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : sendActionName(tmp0_safe_receiver);
                    return tmp1_elvis_lhs == null ? 'Select a Response' : tmp1_elvis_lhs;
                  };
                  tmp = FormAction$default($this, 'Respond', tmp_10, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda_8($this, _this__u8e3s4));
                } else {
                  tmp = null;
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  });
}
function lockProjectAction($this, _this__u8e3s4) {
  var tmp;
  if ($this.qgu_1.j8y()) {
    var tmp_0 = DisputeButton_getInstance();
    var tmp_1 = ($this$ButtonAction) => $this$ButtonAction.baj(get_issues($this.bgv_1)).i1();
    tmp = ButtonAction().dg1('Lock Project', tmp_0, VOID, VOID, VOID, tmp_1, LineItemCompletionForm$lockProjectAction$slambda_0(_this__u8e3s4, $this));
  } else {
    tmp = null;
  }
  return tmp;
}
function actionBar_0($this, _this__u8e3s4) {
  var tmp;
  if (isFinal($this.dgu_1.kfy())) {
    tmp = null;
  } else if ($this.pgu_1) {
    var tmp_0;
    if ($this.ogu_1 == null) {
      tmp_0 = null;
    } else if ($this.dgu_1.kfy().equals(LineItemState_KeepWorking_getInstance())) {
      tmp_0 = null;
    } else {
      var tmp0_safe_receiver = $this.qgu_1.q8y();
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if ($this.qgu_1.v8y()) {
          tmp_2 = tmp0_safe_receiver;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      var tmp1_safe_receiver = tmp_1;
      var tmp_3;
      if (tmp1_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_3 = acceptAction$default($this, _this__u8e3s4, tmp1_safe_receiver);
      }
      tmp_0 = tmp_3;
    }
    tmp = tmp_0;
  } else {
    var tmp_4;
    if ($this.qgu_1.y8x() || $this.qgu_1.z8x()) {
      tmp_4 = FormAction$default($this, 'Request Sign-Off', VOID, VOID, false, VOID, LineItemCompletionForm$actionBar$slambda_0($this));
    } else {
      tmp_4 = null;
    }
    tmp = tmp_4;
  }
  var primaryAction = tmp;
  var pRes = primaryResponseAction($this, _this__u8e3s4);
  var secondaryAction = remember(VOID, VOID, VOID, ($this$remember) => {
    var response = $this$remember.baj(pRes);
    var tmp;
    if (!(response == null)) {
      // Inline function 'kotlin.takeUnless' call
      var this_0 = response.xg0_1;
      var tmp_0;
      var tmp0_safe_receiver = primaryAction;
      if (!equals(this_0, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xg0_1)) {
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      var tmp0_elvis_lhs = tmp_0;
      var tmp_1 = tmp0_elvis_lhs == null ? SecondaryButtonSemantic_getInstance() : tmp0_elvis_lhs;
      tmp = FormAction$default($this, response.wg0_1, VOID, tmp_1, false, VOID, LineItemCompletionForm$actionBar$lambda$slambda_0($this, pRes));
    } else {
      tmp = null;
    }
    return tmp;
  });
  var tertiaryAction = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if (isFinal($this.dgu_1.kfy())) {
      tmp = null;
    } else if ($this.pgu_1 && $this.qgu_1.n8y()) {
      var tmp_0 = SecondaryButtonSemantic_getInstance();
      tmp = FormAction$default($this, 'Propose/Reject', VOID, tmp_0, false, VOID, LineItemCompletionForm$actionBar$lambda$slambda_2($this, $this$remember));
    } else if ($this.pgu_1 && $this.qgu_1.c8y() && $this.fgu_1.p1() === 1) {
      var tmp_1 = SecondaryButtonSemantic_getInstance();
      tmp = FormAction$default($this, 'Adjustment', VOID, tmp_1, false, VOID, LineItemCompletionForm$actionBar$lambda$slambda_4($this));
    } else {
      tmp = null;
    }
    return tmp;
  });
  var tmp2_safe_receiver = lockProjectAction($this, _this__u8e3s4);
  var tmp_5;
  if (tmp2_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = FormAction$default($this, tmp2_safe_receiver.wg0_1, VOID, tmp2_safe_receiver.xg0_1, false, VOID, LineItemCompletionForm$actionBar$slambda_2($this, tmp2_safe_receiver));
  }
  var openLockProjectForm = tmp_5;
  if (get_viewIsWide(_this__u8e3s4)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().hg2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowCollapsingToColumn())(_this__u8e3s4.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.zb8(get_AppDimensions().ig2_1);
    escalateCheckbox($this, view);
    var tmp_6 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Space())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view.fbb(p_0, view_0);
    view.jbb(tmp_6, view_0);
    var tmp_7 = view.ibb(get_centered(view), get_textButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    specCenteredText(view_1, 'Go Back');
    onClick(view_1, VOID, VOID, LineItemCompletionForm$actionBar$slambda_4($this, view_1));
    view.fbb(p_1, view_1);
    view.jbb(tmp_7, view_1);
    if (!(openLockProjectForm == null)) {
      view.jbb(get_centered(view), button(view, openLockProjectForm));
    }
    var tmp_8 = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    applyReactiveActionFormatting(view_2, tertiaryAction);
    view.fbb(p_2, view_2);
    view.jbb(tmp_8, view_2);
    var tmp_9 = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    applyReactiveActionFormatting(view_3, secondaryAction);
    view.fbb(p_3, view_3);
    view.jbb(tmp_9, view_3);
    if (!(primaryAction == null)) {
      var tmp_10 = get_centered(view);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Button())(view.pc());
      var tmp0_elvis_lhs_4 = view.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
      view.ebb(p_4, view_4);
      applyActionFormatting(view_4, primaryAction);
      view.fbb(p_4, view_4);
      view.jbb(tmp_10, view_4);
    }
    _this__u8e3s4.fbb(p, view);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_5 = _this__u8e3s4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? _this__u8e3s4 : tmp0_elvis_lhs_5;
    _this__u8e3s4.ebb(p_5, view_5);
    view_5.xbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (RowOrCol())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.ebb(p_6, view_6);
    view_6.xbm(false);
    view_6.zb8(get_AppDimensions().ig2_1);
    var tmp_11 = view_6.ibb(get_expanding(view_6), get_textButton(view_6));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    view_7.jbb(get_centered(view_7), body(view_7, 'Go Back'));
    onClick(view_7, VOID, VOID, LineItemCompletionForm$actionBar$slambda_6($this, view_7));
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_11, view_7);
    if (!(openLockProjectForm == null)) {
      view_6.jbb(get_expanding(view_6), button(view_6, openLockProjectForm, false));
    }
    var tmp_12 = get_expanding(view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Button())(view_6.pc());
    var tmp0_elvis_lhs_8 = view_6.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
    view_6.ebb(p_8, view_8);
    applyReactiveActionFormatting(view_8, tertiaryAction, false);
    view_6.fbb(p_8, view_8);
    view_6.jbb(tmp_12, view_8);
    var tmp_13 = get_expanding(view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Button())(view_6.pc());
    var tmp0_elvis_lhs_9 = view_6.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
    view_6.ebb(p_9, view_9);
    applyReactiveActionFormatting(view_9, secondaryAction, false);
    view_6.fbb(p_9, view_9);
    view_6.jbb(tmp_13, view_9);
    if (!(primaryAction == null)) {
      var tmp_14 = get_expanding(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_10 = new (Button())(view_6.pc());
      var tmp0_elvis_lhs_10 = view_6.cbb_1;
      var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
      view_6.ebb(p_10, view_10);
      applyActionFormatting(view_10, primaryAction, false);
      view_6.fbb(p_10, view_10);
      view_6.jbb(tmp_14, view_10);
    }
    view_5.fbb(p_6, view_6);
    escalateCheckbox($this, view_5);
    _this__u8e3s4.fbb(p_5, view_5);
  }
}
function escalateCheckbox($this, _this__u8e3s4) {
  if ($this.qgu_1.f8y()) {
    var tmp = get_compact(_this__u8e3s4);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(false);
    var tmp_0 = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Checkbox())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xah(view_0.cbk_1, $this.rgu_1);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    view.jbb(get_centered(view), body(view, 'Raise Issue'));
    view.jbb(get_centered(view), infoBubble(view, "Escalates by putting contractor on formal notice. Timer remains active. Use when unwilling to accept contractor's proposed option."));
    _this__u8e3s4.fbb(p, view);
    _this__u8e3s4.jbb(tmp, view);
  } else if ($this.qgu_1.i8y()) {
    var tmp_1 = get_compact(_this__u8e3s4);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
    _this__u8e3s4.ebb(p_1, view_1);
    view_1.xbm(false);
    var tmp_2 = get_centered(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Frame())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    var size = get_rem_0(1.5);
    var tmp_3 = view_2.ibb(get_centered(view_2), sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, size, size));
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Checkbox())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    var tmp_4 = LineItemCompletionForm$escalateCheckbox$lambda;
    view_3.xah(view_3.cbk_1, $this.sgu_1.tak(tmp_4, LineItemCompletionForm$escalateCheckbox$lambda_0));
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_3, view_3);
    var tmp_5 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, times(size, 1.2), times(size, 1.2));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Button())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.ebb(p_4, view_4);
    var tmp_6 = view_4.ob6_1;
    // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
    Companion_getInstance();
    var tmp$ret$10 = new (LineItemCompletionForm$escalateCheckbox$$inlined$row$1())();
    view_4.jba(tmp_6.ybe(tmp$ret$10));
    onClick(view_4, VOID, VOID, LineItemCompletionForm$escalateCheckbox$slambda_0($this));
    view_2.fbb(p_4, view_4);
    view_2.jbb(tmp_5, view_4);
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_2, view_2);
    var tmp_7 = get_centered(view_1);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_5 = view_1.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
    view_1.ebb(p_5, view_5);
    view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_8 = KMutableProperty0();
    var tmp_9 = TextView$_get_content_$ref_4pzcwl_9(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_9(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.baj($this.sgu_1);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = ' (' + tmp0_safe_receiver.l90_1 + ')';
      }
      var tmp1_elvis_lhs = tmp;
      var tmp$ret$19 = 'File Dispute' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      this_0.set(tmp$ret$19);
      return Unit_instance;
    });
    view_1.fbb(p_5, view_5);
    view_1.jbb(tmp_7, view_5);
    view_1.jbb(get_centered(view_1), infoBubble(view_1, 'Cancels timer, initiates formal dispute period. Can apply to this item or entire project. Parties negotiate through structured options or, after 14 days, either party can lock the project forcing arbitration.'));
    _this__u8e3s4.fbb(p_1, view_1);
    _this__u8e3s4.jbb(tmp_1, view_1);
  }
}
var ResponseFormClass;
function ResponseForm() {
  if (ResponseFormClass === VOID) {
    class $ {
      constructor($outer, action) {
        this.mhr_1 = $outer;
        this.jhr_1 = action;
        var tmp = this;
        tmp.khr_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.jhr_1).ucv() === 'Lock Project');
        var tmp_0 = this;
        tmp_0.lhr_1 = remember(VOID, VOID, VOID, ($this$remember) => banners(($this$banners) => {
          var tmp;
          if (!this.mhr_1.pgu_1) {
            var tmp0_subject = $this$remember.baj(this.mhr_1.vgu_1);
            var tmp_0;
            if (equals(tmp0_subject, MoreInfo_instance)) {
              var escalate = this.mhr_1.qgu_1.u8w() ? 'File Dispute' : 'Raise Issue';
              $this$banners.yfz('C-WIF-RF-MoreInfo-warn', "Use when you need clarification on the client's concern. Request pictures or detailed explanations. Resumes timer. Client can provide info or escalate to " + escalate + '.');
              tmp_0 = Unit_instance;
            } else {
              if (equals(tmp0_subject, KeepWorking_instance)) {
                $this$banners.yfz('C-WIF-RF-KeepWorking-warn', 'Use when you acknowledge additional work is genuinely needed. Clears timer completely. Complete the work, then request sign-off again.');
                tmp_0 = Unit_instance;
              } else {
                if (tmp0_subject instanceof Handled()) {
                  $this$banners.yfz('C-WIF-RF-Handled-warn', "Use this when you've already addressed the concern through quick fixes, cleanup, or clarification. Explain what you did or clarify the existing work. Resumes timer. Client can accept or continue discussion. Optional credit available.");
                  tmp_0 = Unit_instance;
                } else {
                  if (tmp0_subject instanceof ForceComplete()) {
                    var escalated = this.mhr_1.qgu_1.u8w() ? 'a dispute' : 'an issue';
                    $this$banners.yfz('C-WIF-RF-ForceComplete-warn', "Use this to firmly state the work is finished and you've done all you can. This is your final position. Resumes timer. Client can accept or escalate to " + escalated + ' if they disagree. Optional credit available.');
                    tmp_0 = Unit_instance;
                  } else {
                    if (tmp0_subject instanceof RequestSiteVisit()) {
                      var tmp_1;
                      if (this.mhr_1.qgu_1.v8w()) {
                        $this$banners.zfz('C-WIF-RF-RequestSiteVisit-Dispute-dang', 'Request an on-site meeting to discuss the dispute in person. Include suggested meeting times. Submit your proposed settlement after the meeting takes place.');
                        tmp_1 = Unit_instance;
                      } else {
                        $this$banners.yfz('C-WIF-RF-RequestSiteVisit-warn', 'Use to schedule an on-site meeting with the client. Include suggested meeting times in your response. Resumes timer until client confirms visit. After meeting, submit your response based on the discussion.');
                        tmp_1 = Unit_instance;
                      }
                      tmp_0 = tmp_1;
                    } else {
                      if (tmp0_subject instanceof Credit()) {
                        $this$banners.zfz('C-WIF-RF-Credit-dang', "Offer a monetary credit to settle the dispute. Specify the credit amount and explain how this addresses the client's concerns. Client can accept the credit or continue dispute discussion.");
                        tmp_0 = Unit_instance;
                      } else {
                        if (tmp0_subject instanceof Remedy()) {
                          $this$banners.zfz('C-WIF-RF-Remedy-dang', 'Propose a detailed plan to settle the dispute including specific work to be completed, timeline, and approach. Credit can also be included in your plan. Client can accept your plan, propose modifications, or continue dispute discussion.');
                          tmp_0 = Unit_instance;
                        } else {
                          if (tmp0_subject instanceof Appeal()) {
                            $this$banners.zfz('C-WIF-RF-Appeal-dang', 'Challenge the dispute by explaining why the work meets contract requirements. This is your formal position. Client can accept your appeal or continue discussion.');
                            tmp_0 = Unit_instance;
                          } else {
                            tmp_0 = Unit_instance;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        }));
      }
      ud6(_this__u8e3s4) {
        var tmp = get_unpadded(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(LineItemCompletionForm$ResponseForm$render$slambda_0());
        var tmp_0 = view.ibb(get_scrolling(view), align(view, Align_Stretch_getInstance(), Align_Center_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.eba(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 2.0);
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_0.fbb(p_1, view_1);
        var tmp_1 = view_0.ibb(view_0.ibb(get_centered(view_0), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, times(get_AppDimensions().eg2_1, 0.75))), view_0.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.xbm(true);
        responseForm(this, view_2, lens(this.jhr_1, LineItemCompletionForm$ResponseForm$render$lambda));
        if (get_viewIsNarrow(view_2)) {
          view_2.jbb(get_atEnd(view_2), this.nhr(view_2));
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc(), 0.5);
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_2.fbb(p_3, view_3);
        actionBar(this, view_2, this.jhr_1);
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Space())(view_0.pc(), 2.0);
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_0.fbb(p_4, view_4);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      nhr(_this__u8e3s4) {
        var tmp = get_tertiaryButton(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        specCenteredText(view, '+ Attachment');
        onClick(view, 'Upload Attachments', VOID, LineItemCompletionForm$ResponseForm$attachmentButton$slambda_0(view, this.mhr_1));
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'ResponseForm', VOID, VOID, [Page()]);
    ResponseFormClass = $;
  }
  return ResponseFormClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      fht(lineItem, project, lens, scope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_createDialog__bkuuho.bind(VOID, this, lineItem, project, lens, scope), $completion);
      }
      cgu(lineItem, project, lens, scope, $completion, $super) {
        scope = scope === VOID ? null : scope;
        return $super === VOID ? this.fht(lineItem, project, lens, scope, $completion) : $super.fht.call(this, lineItem, project, lens, scope, $completion);
      }
    }
    initMetadataForCompanion($, VOID, VOID, [4]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var LineItemCompletionForm$renderAsDialog$slambdaClass;
function LineItemCompletionForm$renderAsDialog$slambda() {
  if (LineItemCompletionForm$renderAsDialog$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground) {
        this.ght_1 = this$0;
        this.hht_1 = $$this$dismissBackground;
      }
      sao($completion) {
        closeForm(this.ght_1, this.hht_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$renderAsDialog$slambdaClass = $;
  }
  return LineItemCompletionForm$renderAsDialog$slambdaClass;
}
function LineItemCompletionForm$renderAsDialog$slambda_0(this$0, $$this$dismissBackground) {
  var i = new (LineItemCompletionForm$renderAsDialog$slambda())(this$0, $$this$dismissBackground);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$page$lambda($this$forEachAnimated, reason) {
  return $this$forEachAnimated.jbb($this$forEachAnimated.ibb(get_centered($this$forEachAnimated), $this$forEachAnimated.hbb(StateTagSemantic().wgt(reason))), body($this$forEachAnimated, reason.g90()));
}
var LineItemCompletionForm$page$slambdaClass;
function LineItemCompletionForm$page$slambda() {
  if (LineItemCompletionForm$page$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.iht_1 = $$this$button;
        this.jht_1 = this$0;
      }
      sao($completion) {
        // Inline function 'kotlin.run' call
        var $this$run = get_mainPageNavigator(this.iht_1);
        var tmp = lastOrNull($this$run.gbn_1.f2());
        if (!(tmp instanceof ProjectView())) {
          $this$run.dbw(this.jht_1.pgu_1 ? new (ClientProject())(this.jht_1.egu_1.x7a_1) : new (ContractorProject())(this.jht_1.egu_1.x7a_1));
        }
        JumpTo_getInstance().rg3_1.zg4(this.jht_1.dgu_1.kf9_1, VOID, VOID, false);
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$page$slambdaClass = $;
  }
  return LineItemCompletionForm$page$slambdaClass;
}
function LineItemCompletionForm$page$slambda_0($$this$button, this$0) {
  var i = new (LineItemCompletionForm$page$slambda())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$page$lambda_0($this$forEachAnimated, reason) {
  return $this$forEachAnimated.jbb($this$forEachAnimated.ibb(get_centered($this$forEachAnimated), $this$forEachAnimated.hbb(StateTagSemantic().wgt(reason))), body($this$forEachAnimated, reason.g90()));
}
function LineItemCompletionForm$page$lambda_1($this$leftExpandButton) {
  boldSubTitle($this$leftExpandButton, 'Form History');
  return Unit_instance;
}
var LineItemCompletionForm$previousMessages$slambdaClass;
function LineItemCompletionForm$previousMessages$slambda() {
  if (LineItemCompletionForm$previousMessages$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, this$0) {
        this.ohr_1 = $$this$col;
        this.phr_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$previousMessages$slambdaClass = $;
  }
  return LineItemCompletionForm$previousMessages$slambdaClass;
}
function LineItemCompletionForm$previousMessages$slambda_0($$this$col, this$0) {
  var i = new (LineItemCompletionForm$previousMessages$slambda())($$this$col, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var LineItemCompletionForm$renderReplies$slambdaClass;
function LineItemCompletionForm$renderReplies$slambda() {
  if (LineItemCompletionForm$renderReplies$slambdaClass === VOID) {
    class $ {
      constructor($viewReplies, $newReply) {
        this.kht_1 = $viewReplies;
        this.lht_1 = $newReply;
      }
      sao($completion) {
        set_value(this.kht_1, true);
        this.lht_1.mam('');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$renderReplies$slambdaClass = $;
  }
  return LineItemCompletionForm$renderReplies$slambdaClass;
}
function LineItemCompletionForm$renderReplies$slambda_0($viewReplies, $newReply) {
  var i = new (LineItemCompletionForm$renderReplies$slambda())($viewReplies, $newReply);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemCompletionForm$renderReplies$lambda$slambdaClass;
function LineItemCompletionForm$renderReplies$lambda$slambda() {
  if (LineItemCompletionForm$renderReplies$lambda$slambdaClass === VOID) {
    class $ {
      constructor($reply, $$this$col, this$0, $viewReplies) {
        this.qhr_1 = $reply;
        this.rhr_1 = $$this$col;
        this.shr_1 = this$0;
        this.thr_1 = $viewReplies;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$renderReplies$lambda$slambdaClass = $;
  }
  return LineItemCompletionForm$renderReplies$lambda$slambdaClass;
}
function LineItemCompletionForm$renderReplies$lambda$slambda_0($reply, $$this$col, this$0, $viewReplies) {
  var i = new (LineItemCompletionForm$renderReplies$lambda$slambda())($reply, $$this$col, this$0, $viewReplies);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var LineItemCompletionForm$renderReplies$lambda$slambdaClass_0;
function LineItemCompletionForm$renderReplies$lambda$slambda_1() {
  if (LineItemCompletionForm$renderReplies$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($newReply) {
        this.mht_1 = $newReply;
      }
      sao($completion) {
        this.mht_1.mam('');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$renderReplies$lambda$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$renderReplies$lambda$slambdaClass_0;
}
function LineItemCompletionForm$renderReplies$lambda$slambda_2($newReply) {
  var i = new (LineItemCompletionForm$renderReplies$lambda$slambda_1())($newReply);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$renderReplies$lambda(it) {
  return it == null ? '' : it;
}
function LineItemCompletionForm$renderReplies$lambda_0(it) {
  return it;
}
var LineItemCompletionForm$renderReplies$slambdaClass_0;
function LineItemCompletionForm$renderReplies$slambda_1() {
  if (LineItemCompletionForm$renderReplies$slambdaClass_0 === VOID) {
    class $ {
      constructor($newReply) {
        this.nht_1 = $newReply;
      }
      sao($completion) {
        this.nht_1.mam(null);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$renderReplies$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$renderReplies$slambdaClass_0;
}
function LineItemCompletionForm$renderReplies$slambda_2($newReply) {
  var i = new (LineItemCompletionForm$renderReplies$slambda_1())($newReply);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemCompletionForm$renderReplies$slambdaClass_1;
function LineItemCompletionForm$renderReplies$slambda_3() {
  if (LineItemCompletionForm$renderReplies$slambdaClass_1 === VOID) {
    class $ {
      constructor($message, this$0, $newReply) {
        this.uhr_1 = $message;
        this.vhr_1 = this$0;
        this.whr_1 = $newReply;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$renderReplies$slambdaClass_1 = $;
  }
  return LineItemCompletionForm$renderReplies$slambdaClass_1;
}
function LineItemCompletionForm$renderReplies$slambda_4($message, this$0, $newReply) {
  var i = new (LineItemCompletionForm$renderReplies$slambda_3())($message, this$0, $newReply);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemCompletionForm$acceptAction$slambdaClass;
function LineItemCompletionForm$acceptAction$slambda() {
  if (LineItemCompletionForm$acceptAction$slambdaClass === VOID) {
    class $ {
      constructor($proposal, this$0, $this_acceptAction) {
        this.oht_1 = $proposal;
        this.pht_1 = this$0;
        this.qht_1 = $this_acceptAction;
      }
      wah($this$FormAction, $completion) {
        var text = acceptConfirmationText(this.oht_1, this.pht_1.qgu_1);
        confirmationDialog(this.qht_1, text.tw_1, text.uw_1, text.vw_1, VOID, VOID, VOID, VOID, VOID, VOID, LineItemCompletionForm$acceptAction$slambda$slambda_0(this.pht_1, this.oht_1, this.qht_1));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$acceptAction$slambdaClass = $;
  }
  return LineItemCompletionForm$acceptAction$slambdaClass;
}
function LineItemCompletionForm$acceptAction$slambda_0($proposal, this$0, $this_acceptAction) {
  var i = new (LineItemCompletionForm$acceptAction$slambda())($proposal, this$0, $this_acceptAction);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.rht_1 = this$0;
        this.sht_1 = $this_primaryResponseAction;
      }
      wah($this$FormAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = IssueButton_getInstance();
        var tmp_1 = LineItemCompletionForm$primaryResponseAction$lambda$slambda$lambda;
        tmp.xgd(new (GenericConfirmationDialog())('Raise Issue?', 'This escalates to a formal Issue and puts the contractor on notice. Funds release timer pauses until contractor responds. Contractor will have additional response options to address your concerns.', VOID, 'Raise Issue', VOID, tmp_0, VOID, VOID, tmp_1, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_0(this.rht_1, this.sht_1)));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_0(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda())(this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_0;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_1() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_primaryResponseAction, this$0) {
        this.tht_1 = $this_primaryResponseAction;
        this.uht_1 = this$0;
      }
      wah($this$FormAction, $completion) {
        var tmp = equals(this.uht_1.sgu_1.f2(), DisputeType_LineItem_getInstance()) ? 'This puts this work item on hold and starts the formal dispute period. Other work items can continue. Parties work together to settle the dispute through structured options.' : 'This escalates to a formal dispute and freezes all work on the project. Parties work together to settle through structured options. If not settled after 14 days, either party can lock the project. After lock, parties can still reach agreement and unlock, or proceed to independent decision.';
        var tmp_0 = DisputeButton_getInstance();
        confirmationDialog(this.tht_1, 'File Dispute?', tmp, 'File Dispute', VOID, tmp_0, VOID, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_2(this.uht_1, this.tht_1));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_0;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_2($this_primaryResponseAction, this$0) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda_1())($this_primaryResponseAction, this$0);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_1;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_3() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($this_primaryResponseAction, this$0) {
        this.vht_1 = $this_primaryResponseAction;
        this.wht_1 = this$0;
      }
      wah($this$FormAction, $completion) {
        confirmationDialog(this.vht_1, 'Provide More Info?', 'This sends your additional information to the contractor and pauses the funds release timer.', 'Provide Info', VOID, VOID, VOID, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_4(this.wht_1, this.vht_1));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_1 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_1;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_4($this_primaryResponseAction, this$0) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda_3())($this_primaryResponseAction, this$0);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_2;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_5() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_primaryResponseAction, this$0) {
        this.xht_1 = $this_primaryResponseAction;
        this.yht_1 = this$0;
      }
      wah($this$FormAction, $completion) {
        var tmp = this.yht_1.qgu_1.u8w() ? 'Resubmit Issue?' : 'Submit Not Ready?';
        var tmp_0 = this.yht_1.qgu_1.u8w() ? 'This keeps the Issue active and sends your updated concerns to the contractor. Funds release timer pauses until contractor responds.' : 'This pauses the funds release timer and sends your feedback to the contractor for their response.';
        var tmp_1 = this.yht_1.qgu_1.u8w() ? 'Resubmit Issue' : 'Mark Not Ready';
        var tmp_2 = this.yht_1.qgu_1.u8w() ? IssueButton_getInstance() : NotReadyButton_getInstance();
        confirmationDialog(this.xht_1, tmp, tmp_0, tmp_1, VOID, tmp_2, VOID, VOID, VOID, VOID, LineItemCompletionForm$primaryResponseAction$lambda$slambda$slambda_6(this.yht_1, this.xht_1));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_2 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_2;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_6($this_primaryResponseAction, this$0) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda_5())($this_primaryResponseAction, this$0);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_3;
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_7() {
  if (LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.khs_1 = this$0;
        this.lhs_1 = $this_primaryResponseAction;
      }
      wah($this$FormAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$FormAction), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_3 = $;
  }
  return LineItemCompletionForm$primaryResponseAction$lambda$slambdaClass_3;
}
function LineItemCompletionForm$primaryResponseAction$lambda$slambda_8(this$0, $this_primaryResponseAction) {
  var i = new (LineItemCompletionForm$primaryResponseAction$lambda$slambda_7())(this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$lockProjectAction$slambdaClass;
function LineItemCompletionForm$lockProjectAction$slambda() {
  if (LineItemCompletionForm$lockProjectAction$slambdaClass === VOID) {
    class $ {
      constructor($this_lockProjectAction, this$0) {
        this.zht_1 = $this_lockProjectAction;
        this.ahu_1 = this$0;
      }
      wah($this$ButtonAction, $completion) {
        confirmLockProject(this.zht_1, LineItemCompletionForm$lockProjectAction$slambda$slambda_0(this.ahu_1, this.zht_1));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$lockProjectAction$slambdaClass = $;
  }
  return LineItemCompletionForm$lockProjectAction$slambdaClass;
}
function LineItemCompletionForm$lockProjectAction$slambda_0($this_lockProjectAction, this$0) {
  var i = new (LineItemCompletionForm$lockProjectAction$slambda())($this_lockProjectAction, this$0);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$slambdaClass;
function LineItemCompletionForm$actionBar$slambda() {
  if (LineItemCompletionForm$actionBar$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bhu_1 = this$0;
      }
      wah($this$FormAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = listOf(this.bhu_1.dgu_1);
        tmp.xgd(WorkItemRequestSignOffDialog(tmp_0, this.bhu_1.fgu_1, VOID, ($this$WorkItemRequestSignOffDialog, it) => {
          get_dialogStack().ngd();
          var tmp;
          if (it) {
            closeForm(this.bhu_1, $this$WorkItemRequestSignOffDialog);
            tmp = Unit_instance;
          }
          return Unit_instance;
        }));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$actionBar$slambdaClass = $;
  }
  return LineItemCompletionForm$actionBar$slambdaClass;
}
function LineItemCompletionForm$actionBar$slambda_0(this$0) {
  var i = new (LineItemCompletionForm$actionBar$slambda())(this$0);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$lambda$slambdaClass;
function LineItemCompletionForm$actionBar$lambda$slambda() {
  if (LineItemCompletionForm$actionBar$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $pRes) {
        this.chu_1 = this$0;
        this.dhu_1 = $pRes;
      }
      wah($this$FormAction, $completion) {
        get_dialogStack().xgd(new (ResponseForm())(this.chu_1, get_waitForNotNull(this.dhu_1)));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$actionBar$lambda$slambdaClass = $;
  }
  return LineItemCompletionForm$actionBar$lambda$slambdaClass;
}
function LineItemCompletionForm$actionBar$lambda$slambda_0(this$0, $pRes) {
  var i = new (LineItemCompletionForm$actionBar$lambda$slambda())(this$0, $pRes);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$lambda$slambdaClass_0;
function LineItemCompletionForm$actionBar$lambda$slambda_1() {
  if (LineItemCompletionForm$actionBar$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $this_remember) {
        this.ehu_1 = this$0;
        this.fhu_1 = $this_remember;
      }
      wah($this$FormAction, $completion) {
        var action = 'Propose Solution';
        var tmp = get_dialogStack();
        var tmp_0 = LineItemCompletionForm$actionBar$lambda$slambda$slambda_0(this.fhu_1);
        // Inline function 'kotlin.also' call
        var this_0 = new (TextAndFileInputDialog())(action, 'Do you have a solution in mind to end the dispute? If so, you can propose a solution to the contractor. Once sent, the contractor can review and respond. You cannot modify this or send another until the contractor responds or 24 hours pass.', action, VOID, this.ehu_1.agv_1, VOID, tmp_0, VOID, LineItemCompletionForm$actionBar$lambda$slambda$slambda_2(this.ehu_1));
        this_0.qgs_1.mam(this.ehu_1.bgv_1.f2());
        tmp.xgd(this_0);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$actionBar$lambda$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$actionBar$lambda$slambdaClass_0;
}
function LineItemCompletionForm$actionBar$lambda$slambda_2(this$0, $this_remember) {
  var i = new (LineItemCompletionForm$actionBar$lambda$slambda_1())(this$0, $this_remember);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$lambda$slambdaClass_1;
function LineItemCompletionForm$actionBar$lambda$slambda_3() {
  if (LineItemCompletionForm$actionBar$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.rhs_1 = this$0;
      }
      wah($this$FormAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$FormAction), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$actionBar$lambda$slambdaClass_1 = $;
  }
  return LineItemCompletionForm$actionBar$lambda$slambdaClass_1;
}
function LineItemCompletionForm$actionBar$lambda$slambda_4(this$0) {
  var i = new (LineItemCompletionForm$actionBar$lambda$slambda_3())(this$0);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$slambdaClass_0;
function LineItemCompletionForm$actionBar$slambda_1() {
  if (LineItemCompletionForm$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $lockProject) {
        this.ghu_1 = this$0;
        this.hhu_1 = $lockProject;
      }
      wah($this$FormAction, $completion) {
        get_dialogStack().xgd(new (ResponseForm())(this.ghu_1, new (Constant())(_Constant___init__impl__v45mub(this.hhu_1))));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemCompletionForm$actionBar$slambdaClass_0 = $;
  }
  return LineItemCompletionForm$actionBar$slambdaClass_0;
}
function LineItemCompletionForm$actionBar$slambda_2(this$0, $lockProject) {
  var i = new (LineItemCompletionForm$actionBar$slambda_1())(this$0, $lockProject);
  var l = ($this$FormAction, $completion) => i.wah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var LineItemCompletionForm$actionBar$slambdaClass_1;
function LineItemCompletionForm$actionBar$slambda_3() {
  if (LineItemCompletionForm$actionBar$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.ihu_1 = this$0;
        this.jhu_1 = $$this$button;
      }
      sao($completion) {
        closeForm(this.ihu_1, this.jhu_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$actionBar$slambdaClass_1 = $;
  }
  return LineItemCompletionForm$actionBar$slambdaClass_1;
}
function LineItemCompletionForm$actionBar$slambda_4(this$0, $$this$button) {
  var i = new (LineItemCompletionForm$actionBar$slambda_3())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemCompletionForm$actionBar$slambdaClass_2;
function LineItemCompletionForm$actionBar$slambda_5() {
  if (LineItemCompletionForm$actionBar$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.khu_1 = this$0;
        this.lhu_1 = $$this$button;
      }
      sao($completion) {
        closeForm(this.khu_1, this.lhu_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$actionBar$slambdaClass_2 = $;
  }
  return LineItemCompletionForm$actionBar$slambdaClass_2;
}
function LineItemCompletionForm$actionBar$slambda_6(this$0, $$this$button) {
  var i = new (LineItemCompletionForm$actionBar$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LineItemCompletionForm$escalateCheckbox$lambda(it) {
  return !(it == null);
}
function LineItemCompletionForm$escalateCheckbox$lambda_0(it) {
  return null;
}
var LineItemCompletionForm$escalateCheckbox$$inlined$row$1Class;
function LineItemCompletionForm$escalateCheckbox$$inlined$row$1() {
  if (LineItemCompletionForm$escalateCheckbox$$inlined$row$1Class === VOID) {
    class $ {
      fd1(theme) {
        var tmp = HoverSemantic_getInstance();
        return theme.rd1('nohvr', VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp, LineItemCompletionForm$escalateCheckbox$o$invoke$lambda))).ab1_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    LineItemCompletionForm$escalateCheckbox$$inlined$row$1Class = $;
  }
  return LineItemCompletionForm$escalateCheckbox$$inlined$row$1Class;
}
var LineItemCompletionForm$escalateCheckbox$slambdaClass;
function LineItemCompletionForm$escalateCheckbox$slambda() {
  if (LineItemCompletionForm$escalateCheckbox$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.mhu_1 = this$0;
      }
      sao($completion) {
        if (!(this.mhu_1.sgu_1.f2() == null)) {
          this.mhu_1.sgu_1.mam(null);
        } else {
          var tmp = get_dialogStack();
          tmp.xgd(new (DisputeWorkItemConfirmation())(LineItemCompletionForm$escalateCheckbox$slambda$slambda_0(this.mhu_1)));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemCompletionForm$escalateCheckbox$slambdaClass = $;
  }
  return LineItemCompletionForm$escalateCheckbox$slambdaClass;
}
function LineItemCompletionForm$escalateCheckbox$slambda_0(this$0) {
  var i = new (LineItemCompletionForm$escalateCheckbox$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ResponseState_Completed_getInstance() {
  ResponseState_initEntries();
  return ResponseState_Completed_instance;
}
function ResponseState_Dispute_getInstance() {
  ResponseState_initEntries();
  return ResponseState_Dispute_instance;
}
function ResponseState_FileDispute_getInstance() {
  ResponseState_initEntries();
  return ResponseState_FileDispute_instance;
}
function ResponseState_Resolving_getInstance() {
  ResponseState_initEntries();
  return ResponseState_Resolving_instance;
}
function ResponseState_Issue_getInstance() {
  ResponseState_initEntries();
  return ResponseState_Issue_instance;
}
function ResponseState_RaiseIssue_getInstance() {
  ResponseState_initEntries();
  return ResponseState_RaiseIssue_instance;
}
function ResponseState_NotReady_getInstance() {
  ResponseState_initEntries();
  return ResponseState_NotReady_instance;
}
var LineItemCompletionFormClass;
function LineItemCompletionForm() {
  if (LineItemCompletionFormClass === VOID) {
    class $ {
      constructor(lineItem, project, messages, replies, client, contractor, role, lens, scopeInfo) {
        scopeInfo = scopeInfo === VOID ? null : scopeInfo;
        this.dgu_1 = lineItem;
        this.egu_1 = project;
        this.fgu_1 = messages;
        this.ggu_1 = replies;
        this.hgu_1 = client;
        this.igu_1 = contractor;
        this.jgu_1 = role;
        this.kgu_1 = lens;
        this.lgu_1 = scopeInfo;
        this.mgu_1 = new (Constant())(_Constant___init__impl__v45mub(this.dgu_1.lf9_1 + ' Form'));
        this.ngu_1 = new (IssueNode())();
        this.ogu_1 = lastOrNull(this.fgu_1);
        this.pgu_1 = this.kgu_1.xgj();
        this.qgu_1 = new (CompletionFlowPermissions())(this.dgu_1.hf9_1, this.pgu_1, this.jgu_1, this.fgu_1, this.egu_1.h7c_1);
        this.rgu_1 = Signal().fak(false);
        this.sgu_1 = Signal().fak(null);
        var tmp = this;
        tmp.tgu_1 = remember(VOID, VOID, VOID, ($this$remember) => !($this$remember.baj(this.sgu_1) == null) ? EscalationLevel_Disputed_getInstance() : $this$remember.baj(this.rgu_1) ? EscalationLevel_Issue_getInstance() : this.qgu_1.n8w());
        this.ugu_1 = this.qgu_1.p8x_1;
        this.vgu_1 = assertNotNull(validated(Signal().fak(this.pgu_1 && this.qgu_1.u8y() ? new (ClientResponse())() : null), this.ngu_1));
        this.wgu_1 = this.dgu_1.hf9_1.o91();
        this.xgu_1 = Signal().fak(null);
        var tmp_0 = this;
        // Inline function 'kotlin.apply' call
        var this_0 = this.ngu_1.tat();
        validateReactive(this_0, ($this$validateReactive) => {
          var tmp0_subject = $this$validateReactive.baj(this.vgu_1);
          var tmp;
          if (tmp0_subject instanceof Credit()) {
            var tmp_0 = $this$validateReactive.baj(this.xgu_1);
            var credit = tmp_0 == null ? null : tmp_0.a5s_1;
            var tmp_1;
            var tmp_2 = credit;
            if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
              tmp_1 = 'Credit cannot be blank';
            } else {
              if (MonetaryValue__compareTo_impl_w7ul1r(credit, Companion_instance.p91(0n)) <= 0) {
                tmp_1 = 'Credit must be greater than 0';
              } else {
                if (MonetaryValue__compareTo_impl_w7ul1r(this.wgu_1, credit) < 0) {
                  tmp_1 = 'Credit cannot exceed ' + MonetaryValue__toString_impl_xslc77(this.wgu_1);
                } else {
                  tmp_1 = null;
                }
              }
            }
            tmp = tmp_1;
          } else {
            var tmp_3;
            if (tmp0_subject instanceof Handled()) {
              tmp_3 = true;
            } else {
              var tmp_4;
              if (tmp0_subject instanceof ForceComplete()) {
                tmp_4 = true;
              } else {
                tmp_4 = tmp0_subject instanceof Remedy();
              }
              tmp_3 = tmp_4;
            }
            if (tmp_3) {
              var tmp_5 = $this$validateReactive.baj(this.xgu_1);
              var credit_0 = tmp_5 == null ? null : tmp_5.a5s_1;
              var tmp_6;
              var tmp_7 = credit_0;
              if ((tmp_7 == null ? null : new (MonetaryValue())(tmp_7)) == null) {
                tmp_6 = null;
              } else {
                if (MonetaryValue__compareTo_impl_w7ul1r(credit_0, Companion_instance.p91(0n)) <= 0) {
                  tmp_6 = 'Credit must be greater than 0';
                } else {
                  if (MonetaryValue__compareTo_impl_w7ul1r(this.wgu_1, credit_0) < 0) {
                    tmp_6 = 'Credit cannot exceed ' + MonetaryValue__toString_impl_xslc77(this.wgu_1);
                  } else {
                    tmp_6 = null;
                  }
                }
              }
              tmp = tmp_6;
            } else {
              tmp = null;
            }
          }
          return tmp;
        });
        tmp_0.ygu_1 = this_0;
        this.zgu_1 = ReactiveMutableList().tam();
        this.agv_1 = 35;
        var tmp_1 = this;
        var tmp_2 = validated(Signal().fak(''), this.ngu_1);
        var tmp_3 = 'Message must be at least ' + this.agv_1 + ' characters';
        tmp_1.bgv_1 = assert(tmp_2, tmp_3, VOID, VOID, (it) => it.length >= this.agv_1);
        var tmp_4 = this;
        tmp_4.cgv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).dfw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectTimer()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$3);
          var tmp$ret$5 = and(eq(get_lineItem_2(it), this.dgu_1.kf9_1), eq(get_executed(it), null));
          var tmp$ret$6 = new (Query())(tmp$ret$5, orderBy, 0, 100);
          return $this$remember.baj(tmp.feo(tmp$ret$6));
        });
        var tmp_5 = this;
        tmp_5.dgv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$remember.baj(this.cgv_1);
          var tmp$ret$8;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.z7t_1.equals(TimerAction_CompleteLineItem_getInstance())) {
                tmp$ret$8 = element;
                break $l$block;
              }
            }
            tmp$ret$8 = null;
          }
          return tmp$ret$8;
        });
        var tmp_6 = this;
        tmp_6.egv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$remember.baj(this.cgv_1);
          var tmp$ret$11;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.z7t_1.equals(TimerAction_AllowLockProject_getInstance())) {
                tmp$ret$11 = element;
                break $l$block_0;
              }
            }
            tmp$ret$11 = null;
          }
          return tmp$ret$11;
        });
        var tmp_7 = this;
        tmp_7.fgv_1 = remember(VOID, VOID, VOID, ($this$remember) => this.dgu_1.kfy().equals(LineItemState_Complete_getInstance()) ? ResponseState_Completed_getInstance() : !($this$remember.baj(this.sgu_1) == null) ? ResponseState_FileDispute_getInstance() : $this$remember.baj(this.rgu_1) ? ResponseState_RaiseIssue_getInstance() : this.dgu_1.kfy().equals(LineItemState_Resolving_getInstance()) ? ResponseState_Resolving_getInstance() : this.qgu_1.v8w() ? ResponseState_Dispute_getInstance() : this.qgu_1.u8w() ? ResponseState_Issue_getInstance() : ResponseState_NotReady_getInstance());
        var tmp_8 = this;
        tmp_8.ggv_1 = remember(VOID, VOID, VOID, ($this$remember) => this.qgu_1.a8y() || (!this.pgu_1 && setOf([LineItemState_Disputed_getInstance(), LineItemState_ResolveLater_getInstance()]).t1(this.dgu_1.kfy())));
        var tmp_9 = this;
        tmp_9.hgv_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var tmp0 = $this$mutableRemember.baj(this.ggu_1);
          var tmp$ret$13;
          $l$block_2: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$13 = false;
              break $l$block_2;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!element.t92().t1($this$mutableRemember.baj(get_session()).efv_1)) {
                tmp$ret$13 = true;
                break $l$block_2;
              }
            }
            tmp$ret$13 = false;
          }
          return tmp$ret$13;
        });
        var tmp_10 = this;
        var tmp0 = this.fgu_1;
        var tmp$ret$16;
        $l$block_3: {
          // Inline function 'kotlin.collections.lastOrNull' call
          var iterator = tmp0.u1(tmp0.p1());
          while (iterator.v6()) {
            var element = iterator.x6();
            if (get_isSignOff(element.f8w())) {
              tmp$ret$16 = element;
              break $l$block_3;
            }
          }
          tmp$ret$16 = null;
        }
        var tmp0_safe_receiver = tmp$ret$16;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g6h_1;
        tmp_10.igv_1 = tmp1_safe_receiver == null ? null : format(tmp1_safe_receiver, Formats_getInstance().k8z_1);
        var tmp_11 = this;
        tmp_11.jgv_1 = remember(VOID, VOID, VOID, ($this$remember) => banners(($this$banners) => {
          var tmp0_safe_receiver = $this$remember.baj(this.dgv_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x7t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : format(tmp1_safe_receiver, Formats_getInstance().k8z_1);
          var autoRelease = tmp2_elvis_lhs == null ? '...' : tmp2_elvis_lhs;
          var tmp;
          if (this.qgu_1.j8y()) {
            tmp = 'Either party can lock the project. Locking ends negotiations and requires a formal and binding dispute resolution decision to release funds';
          } else {
            var tmp3_safe_receiver = $this$remember.baj(this.egv_1);
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x7t_1;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : format(tmp4_safe_receiver, Formats_getInstance().k8z_1);
            tmp = 'Either party can lock the project on ' + (tmp5_elvis_lhs == null ? '...' : tmp5_elvis_lhs);
          }
          var lockAvailableMsg = tmp;
          var timerRunningWarning = 'WIF-TimerRunning-warn';
          var lockAvailableWarning = 'WIF-LockProject-warn';
          var tmp_0;
          if (this.egu_1.w7b_1.equals(ProjectState_Locked_getInstance())) {
            var tmp6_elvis_lhs = this.egu_1.j7c_1;
            var tmp_1;
            if (tmp6_elvis_lhs == null) {
              throw PlainTextException().jcw("Cannot find project lock info, this shouldn't happen, please report this.");
            } else {
              tmp_1 = tmp6_elvis_lhs;
            }
            var info = tmp_1;
            var who = info.r6q_1 ? this.hgu_1.f5c_1 : this.igu_1.x5i_1;
            $this$banners.xfz('WIF-ProjectLocked', who + ' locked the project on ' + format(info.q6q_1.q54_1, Formats_getInstance().k8z_1) + ". Funds remain in escrow and will only be released per Stoze's Terms of Service (stoze.io/platform-terms). No further platform actions are available.");
            $this$banners.yfz('WIF-ProjectLocked-warn', 'Funds held in FDIC-insured escrow. Resolution required per Terms of Service.');
            return Unit_instance;
          }
          var tmp_2;
          if (this.pgu_1) {
            var tmp_3;
            var tmp_4;
            if (this.fgu_1.p1() === 1) {
              var tmp7_safe_receiver = this.ogu_1;
              var tmp_5 = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.f8w();
              tmp_4 = tmp_5 instanceof RequestComplete();
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              $this$banners.xfz('H-WIF-RequestComplete-info', 'Ready to approve? "Approve Work" releases funds. "Not Ready" pauses funds release, requires contractor response. "Minor Adjustments" releases funds with punch tasks.');
              $this$banners.yfz(timerRunningWarning, 'Contractor requested sign-off on ' + this.igv_1 + ". Review and approve promptly to release funds, or mark 'Not Ready' if work needs attention. If no action is taken within 14 days, funds release on " + autoRelease + '.');
              tmp_3 = Unit_instance;
            } else {
              var tmp8_safe_receiver = this.ogu_1;
              var tmp_6 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.f8w();
              if (tmp_6 instanceof MoreInfo()) {
                $this$banners.xfz('H-WIF-MoreInfo-info', 'Contractor requested more information. Review their question and respond with the requested details or attachments.');
                $this$banners.yfz(timerRunningWarning, 'If no response is given funds will release on ' + autoRelease + '.');
                tmp_3 = Unit_instance;
              } else {
                if (this.dgu_1.kfy().equals(LineItemState_KeepWorking_getInstance())) {
                  $this$banners.xfz('H-WIF-KeepWorking-info', 'Contractor acknowledged additional work is needed and will resubmit for sign-off after completion.');
                  $this$banners.yfz('H-WIF-TimerNotRunning-KeepWorking', 'The funds release timer has been cleared. A new timer will start when the contractor requests sign-off again.');
                  tmp_3 = Unit_instance;
                } else {
                  var tmp9_safe_receiver = this.ogu_1;
                  var tmp_7 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.f8w();
                  if (tmp_7 instanceof Handled()) {
                    var denial = this.qgu_1.u8w() ? '"Resubmit Issue"' : 'Mark "Not Ready"';
                    $this$banners.xfz('H-WIF-Handled-info', 'Contractor reports your concerns have been addressed. "Accept Handled" to release funds. ' + denial + ' if concerns remain or to escalate.');
                    $this$banners.yfz(timerRunningWarning, 'If no response is given funds will release on ' + autoRelease + '.');
                    tmp_3 = Unit_instance;
                  } else {
                    if (this.dgu_1.kfy().equals(LineItemState_ForceComplete_getInstance())) {
                      var escalate = this.qgu_1.u8w() ? 'File Dispute' : 'Raise Issue';
                      $this$banners.xfz('H-WIF-ForceComplete-info', 'Contractor states work is complete. "Accept Force Complete" to release funds, or "' + escalate + '" if you disagree. Funds release timer is active.');
                      $this$banners.yfz(timerRunningWarning, 'If no response is given funds will auto-release on ' + autoRelease + '.');
                      tmp_3 = Unit_instance;
                    } else {
                      var tmp10_safe_receiver = this.ogu_1;
                      var tmp_8 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.f8w();
                      if (tmp_8 instanceof RequestSiteVisit()) {
                        var tmp_9;
                        if (this.qgu_1.v8w()) {
                          $this$banners.xfz('H-WIF-RequestJobVisit-Dispute-info', 'Contractor requested an on-site meeting to discuss the dispute. Review their suggested times and confirm the visit to pause the timer and schedule a meeting.');
                          $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Confirm the visit to meet and discuss. ' + lockAvailableMsg + '.');
                          tmp_9 = Unit_instance;
                        } else {
                          $this$banners.xfz('H-WIF-RequestJobVisit-info', 'Contractor wants to meet on-site to address concerns. Confirm the visit to pause the timer and schedule a meeting.');
                          $this$banners.yfz(timerRunningWarning, 'If no response is given funds will auto-release on ' + autoRelease + '.');
                          tmp_9 = Unit_instance;
                        }
                        tmp_3 = tmp_9;
                      } else {
                        var tmp11_safe_receiver = this.ogu_1;
                        var tmp_10 = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.f8w();
                        if (tmp_10 instanceof Credit()) {
                          var tmp_11 = this.ogu_1.f8w();
                          $this$banners.xfz('H-WIF-Credit-info', 'Contractor proposed a ' + MonetaryValue__toString_impl_xslc77((tmp_11 instanceof Credit() ? tmp_11 : THROW_CCE()).r8z_1) + ' credit to settle the dispute. Parties have 14 days from dispute filing to reach settlement. Review their explanation and accept the credit or propose an alternative settlement approach.');
                          $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Accept the credit to settle or propose an alternative. ' + lockAvailableMsg + '.');
                          tmp_3 = Unit_instance;
                        } else {
                          var tmp12_safe_receiver = this.ogu_1;
                          var tmp_12 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.f8w();
                          if (tmp_12 instanceof Appeal()) {
                            $this$banners.xfz('H-WIF-Appeal-info', 'Contractor has appealed the dispute, stating the work meets contract requirements. Parties have 14 days from dispute filing to reach settlement. Review their position and accept the appeal or continue dispute discussion.');
                            $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Accept the appeal to settle or continue dispute discussion. ' + lockAvailableMsg + '.');
                            tmp_3 = Unit_instance;
                          } else {
                            var tmp13_safe_receiver = this.ogu_1;
                            var tmp_13 = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.f8w();
                            if (tmp_13 instanceof Remedy()) {
                              // Inline function 'kotlin.text.buildString' call
                              // Inline function 'kotlin.apply' call
                              var this_0 = StringBuilder().d1();
                              var tmp_14 = this.ogu_1.f8w();
                              var r = tmp_14 instanceof Remedy() ? tmp_14 : THROW_CCE();
                              this_0.wb('Contractor proposed a remedy plan with completion date of ');
                              this_0.wb(format(r.h8z_1, Formats_getInstance().j8z_1));
                              var tmp_15 = r.i8z_1;
                              if (!((tmp_15 == null ? null : new (MonetaryValue())(tmp_15)) == null)) {
                                var tmp0_elvis_lhs = r.i8z_1;
                                var tmp_16;
                                var tmp_17 = tmp0_elvis_lhs;
                                if ((tmp_17 == null ? null : new (MonetaryValue())(tmp_17)) == null) {
                                  tmp_16 = Companion_instance.o62(0);
                                } else {
                                  tmp_16 = tmp0_elvis_lhs;
                                }
                                this_0.wb(', including a ' + MonetaryValue__toString_impl_xslc77(tmp_16) + ' credit. ');
                              } else {
                                this_0.wb('. ');
                              }
                              this_0.wb('Parties have 14 days from dispute filing to reach settlement. Review their plan and accept it or propose changes.');
                              var tmp$ret$19 = this_0.toString();
                              $this$banners.xfz('H-WIF-Remedy-info', tmp$ret$19);
                              $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Accept the remedy plan or propose changes. ' + lockAvailableMsg + '. If accepted, lock will be unavailable during plan implementation.');
                              tmp_3 = Unit_instance;
                            } else {
                              var tmp14_safe_receiver = this.ogu_1;
                              var tmp_18 = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.f8w();
                              if (tmp_18 instanceof ClientResolution()) {
                                $this$banners.xfz('H-WIF-ClientResolution-info', 'You proposed an alternative settlement. The contractor can review and respond. You can respond again after the contractor replies or 24 hours pass.');
                                $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. The contractor can respond. ' + lockAvailableMsg + '.');
                                tmp_3 = Unit_instance;
                              } else {
                                if (!this.qgu_1.c8y() && this.dgu_1.kfy().equals(LineItemState_Issue_getInstance())) {
                                  var noResponseText = this.qgu_1.i8y() ? 'Contractor has not responded for 5 days. Continue to wait for their response or File Dispute.' : "If no response within 5 days, you'll have the option to File Dispute.";
                                  $this$banners.xfz('H-WIF-IssueRaised-info', "You've raised a formal Issue. The contractor will respond with options to address your concerns. " + noResponseText);
                                  $this$banners.yfz('H-WIF-IssueRaised-warn', 'Funds release timer is paused while waiting for contractor response.');
                                  tmp_3 = Unit_instance;
                                } else {
                                  if (!this.qgu_1.c8y()) {
                                    var noResponseText_0 = this.qgu_1.f8y() ? 'Contractor has not responded for 5 days. Continue to wait for their response or Raise Issue.' : "If contractor doesn't respond within 5 days, you can Raise Issue.";
                                    $this$banners.xfz('H-WIF-NotAwaitingResponse-info', trimIndent('\n                            Your feedback has been sent to the contractor.\n                \n                            The contractor will review your concerns and communicate with you about their resolution plan. They may adjust, complete outstanding items, or clarify why they feel it should be signed off. ' + noResponseText_0 + '\n                        '));
                                    tmp_3 = Unit_instance;
                                  } else {
                                    if (!(this.dgu_1.mfy() == null)) {
                                      var cmp = this.qgu_1.s8y();
                                      var tmp_19;
                                      if (cmp instanceof Credit()) {
                                        $this$banners.xfz('H-WIF-Complete-Credit', "You accepted the contractor's " + MonetaryValue__toString_impl_xslc77(cmp.r8z_1) + ' credit proposal to settle the dispute. Dispute is resolved and adjusted funds are available for collection.');
                                        tmp_19 = Unit_instance;
                                      } else {
                                        if (cmp instanceof RemedyComplete()) {
                                          var credit = cmp.y8y_1.i8z_1;
                                          var tmp_20;
                                          var tmp_21 = credit;
                                          if (!((tmp_21 == null ? null : new (MonetaryValue())(tmp_21)) == null)) {
                                            $this$banners.xfz('H-WIF-Complete-RemedyPlan-Credit', "You accepted the contractor's completed remedy plan and " + MonetaryValue__toString_impl_xslc77(new (MonetaryValue())(credit) == null ? Companion_instance.o62(0) : credit) + ' credit. Dispute is resolved and adjusted funds are available for collection.');
                                            tmp_20 = Unit_instance;
                                          } else {
                                            $this$banners.xfz('H-WIF-Complete-RemedyPlan', "You accepted the contractor's completed remedy plan. Dispute is resolved and full funds are available for collection.");
                                            tmp_20 = Unit_instance;
                                          }
                                          tmp_19 = tmp_20;
                                        } else {
                                          if (cmp instanceof Appeal()) {
                                            $this$banners.xfz('H-WIF-Complete-Appeal', "You accepted the contractor's appeal. Dispute is resolved and full funds are available for collection.");
                                            tmp_19 = Unit_instance;
                                          } else {
                                            tmp_19 = Unit_instance;
                                          }
                                        }
                                      }
                                      tmp_3 = tmp_19;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            tmp_2 = tmp_3;
          } else {
            var tmp_22;
            var tmp_23;
            if (!this.qgu_1.u8w()) {
              var tmp16_safe_receiver = this.ogu_1;
              var tmp_24 = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.f8w();
              tmp_23 = tmp_24 instanceof RequestComplete();
            } else {
              tmp_23 = false;
            }
            if (tmp_23) {
              $this$banners.xfz('C-WIF-RequestingSignOff-info', 'Your sign-off request was sent on ' + this.igv_1 + ". Client will review and approve to release funds, or mark 'Not Ready' if work needs attention. Keep communication clear and timely to ensure concerns are resolved quickly and approval is secured.");
              $this$banners.yfz('C-WIF-RequestingSignOff-warn', "Awaiting client response. If approved, funds will be available to collect from Stoze within 3 business days. If client marks 'Not Ready,' review their feedback, make necessary adjustments, and resubmit the request. If no response by " + autoRelease + ', work will auto-approve and funds release for collection.');
              tmp_22 = Unit_instance;
            } else {
              if (this.qgu_1.c8y() && this.dgu_1.kfy().equals(LineItemState_NotApproved_getInstance())) {
                $this$banners.xfz('C-WIF-NotReady-info', this.dgu_1.pfy() ? "It's been 5 days since client marked this work Not Ready. Client can now escalate and raise an issue. Review their concerns below and respond. Your options: request more information, acknowledge more work is needed, explain what's been handled, reaffirm work is complete, or request a site visit. Each option restarts or resumes the timer differently." : "Client has marked this work not ready. Review their concerns below and respond. Your options: request more information, acknowledge more work is needed, explain what's been handled, mark work complete, or request a site visit. Each option resumes or pauses the timer differently. Respond within 5 days or client can escalate and raise an issue.");
                $this$banners.yfz('C-WIF-NotReady-warn', 'The funds release timer is paused. It will resume when you submit your response.');
                tmp_22 = Unit_instance;
              } else {
                if (this.dgu_1.kfy().equals(LineItemState_KeepWorking_getInstance())) {
                  $this$banners.xfz('C-WIF-KeepWorking-info', 'You acknowledged this work needs additional completion. Request sign-off again when ready.');
                  $this$banners.yfz('C-WIF-KeepWorking-warn', 'The funds release timer has been cleared. A new timer will start when you request sign-off.');
                  tmp_22 = Unit_instance;
                } else {
                  var tmp19_safe_receiver = this.ogu_1;
                  var tmp_25 = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.f8w();
                  if (tmp_25 instanceof ClientResolution()) {
                    var tmp17_safe_receiver = this.qgu_1.t8y();
                    var tmp_26;
                    if (tmp17_safe_receiver == null) {
                      tmp_26 = null;
                    } else {
                      // Inline function 'kotlin.let' call
                      tmp_26 = tmp17_safe_receiver.f8w().a8z(this.qgu_1.o8x_1.j8x(tmp17_safe_receiver.g6h_1));
                    }
                    var tmp18_elvis_lhs = tmp_26;
                    $this$banners.xfz('C-WIF-ClientResolution-info', 'Client proposed an alternative settlement to your ' + (tmp18_elvis_lhs == null ? '...' : tmp18_elvis_lhs) + '. Review their message and respond with a new solution: offer credit, submit a remedy plan, appeal the dispute, request a site visit, or propose to resolve this later.');
                    $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Review their message and respond with your solution. ' + lockAvailableMsg + '.');
                    tmp_22 = Unit_instance;
                  } else {
                    if (this.qgu_1.c8y() && this.dgu_1.kfy().equals(LineItemState_Issue_getInstance())) {
                      $this$banners.xfz('C-WIF-Issue-info', this.dgu_1.qfy() ? "It's been 5 days since client raised a formal issue. Client can now escalate and File Dispute. Review their concerns below and respond. Your options: request more information, acknowledge more work is needed, explain what's been handled, reaffirm work is complete, request a site visit, or propose to resolve this later. Each option resumes or pauses the timer differently." : "Client has raised a formal Issue about this work. Review their concerns below and respond within 5 days or client can escalate and File Dispute. Your options: request more information, acknowledge more work is needed, explain what's been handled, confirm work is complete, request a site visit, or propose to resolve this later. Each option resumes or pauses the timer differently.");
                      $this$banners.yfz('C-WIF-Issue-warn', 'Funds release timer is paused. It will resume when you submit your response.');
                      tmp_22 = Unit_instance;
                    } else {
                      if (this.qgu_1.c8y() && this.dgu_1.kfy().equals(LineItemState_Disputed_getInstance())) {
                        $this$banners.xfz('C-WIF-Disputed-info', 'Client has filed a formal Dispute. Review their concerns and propose how to settle: offer credit, submit a remedy plan, appeal the dispute, request a site visit, or propose to resolve this later.');
                        $this$banners.yfz('C-WIF-Disputed-warn', 'Funds are on hold. Review the dispute details and choose how to respond. Settlement releases funds; if unresolved after 14 days from dispute filing, either party can lock the project.');
                        tmp_22 = Unit_instance;
                      } else {
                        if (this.qgu_1.j8y()) {
                          $this$banners.yfz('C-WIF-CanLockProject-warn', lockAvailableMsg);
                          tmp_22 = Unit_instance;
                        } else {
                          if (!(this.dgu_1.mfy() == null)) {
                            var cmp_0 = this.qgu_1.s8y();
                            var tmp_27;
                            if (cmp_0 instanceof Credit()) {
                              $this$banners.xfz('C-WIF-Complete-Credit-info', 'Client accepted your ' + MonetaryValue__toString_impl_xslc77(cmp_0.r8z_1) + ' credit proposal to settle the dispute. Dispute is resolved and funds will be available for collection within 3 business days.');
                              var beforeCredit = MonetaryValue__toString_impl_xslc77(MonetaryValue__plus_impl_c1ylt(this.dgu_1.v91(), cmp_0.r8z_1));
                              var credit_0 = MonetaryValue__toString_impl_xslc77(cmp_0.r8z_1);
                              var net = MonetaryValue__toString_impl_xslc77(this.dgu_1.v91());
                              $this$banners.yfz('C-WIF-Complete-Credit-warn', 'Settlement: ' + credit_0 + ' credit applied. Total work value: ' + beforeCredit + '. Net amount for collection: ' + net + '. Funds available within 3 business days.');
                              tmp_27 = Unit_instance;
                            } else {
                              if (cmp_0 instanceof RemedyComplete()) {
                                var credit_1 = cmp_0.y8y_1.i8z_1;
                                var tmp_28;
                                var tmp_29 = credit_1;
                                if (!((tmp_29 == null ? null : new (MonetaryValue())(tmp_29)) == null)) {
                                  $this$banners.xfz('C-WIF-Complete-RemedyPlan-Credit-info', 'Client accepted your completed remedy plan with ' + MonetaryValue__toString_impl_xslc77(credit_1) + ' credit and signed off on the work. Dispute is resolved and funds will be available for collection within 3 business days.');
                                  var beforeCredit_0 = MonetaryValue__toString_impl_xslc77(MonetaryValue__plus_impl_c1ylt(this.dgu_1.v91(), credit_1));
                                  var net_0 = MonetaryValue__toString_impl_xslc77(this.dgu_1.v91());
                                  $this$banners.yfz('C-WIF-Complete-RemedyPlan-Credit-warn', 'Settlement: Remedy plan completed and accepted. ' + MonetaryValue__toString_impl_xslc77(credit_1) + ' credit applied. Total work value: ' + beforeCredit_0 + '. Net amount for collection: ' + net_0 + '. Funds available within 3 business days.');
                                  tmp_28 = Unit_instance;
                                } else {
                                  $this$banners.xfz('C-WIF-Complete-RemedyPlan-info', 'Client accepted your completed remedy plan and signed off on the work. Dispute is resolved and funds will be available for collection within 3 business days.');
                                  $this$banners.yfz('C-WIF-Complete-RemedyPlan-warn', 'Settlement: Remedy plan completed and accepted. Full work amount: ' + MonetaryValue__toString_impl_xslc77(this.dgu_1.v91()) + '. Funds available for collection within 3 business days.');
                                  tmp_28 = Unit_instance;
                                }
                                tmp_27 = tmp_28;
                              } else {
                                if (cmp_0 instanceof Appeal()) {
                                  $this$banners.xfz('C-WIF-Complete-Appeal-info', 'Client accepted your appeal and agrees the work is complete as discussed. Dispute is resolved and funds will be available for collection within 3 business days.');
                                  $this$banners.yfz('C-WIF-Complete-Appeal-warn', 'Settlement: Appeal accepted. Full work amount: ' + MonetaryValue__toString_impl_xslc77(this.dgu_1.v91()) + '. Funds available for collection within 3 business days.');
                                  tmp_27 = Unit_instance;
                                } else {
                                  tmp_27 = Unit_instance;
                                }
                              }
                            }
                            tmp_22 = tmp_27;
                          } else {
                            tmp_22 = Unit_instance;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            tmp_2 = tmp_22;
          }
          return Unit_instance;
        }));
      }
      ucv() {
        return this.mgu_1;
      }
      cgh(_this__u8e3s4) {
        return this.kgu_1.xgj() ? new (ClientProject())(this.egu_1.x7a_1) : new (ContractorProject())(this.egu_1.x7a_1);
      }
      wgs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp0_vertical = get_px(0);
        var tmp1_horizontal = get_AppDimensions().wg1_1;
        view.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
        view.tbo(LineItemCompletionForm$renderAsDialog$slambda_0(this, view));
        var tmp_0 = get_atTopCenter(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.hba(Edges().ad0(get_px(0)).gd0(VOID, get_rem(3), VOID, get_rem(5)));
        view_0.cb9(true);
        view_0.jbb(view_0.ibb(view_0.ibb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), get_atTopCenter(view_0)), view_0.hbb(DialogSemantic_getInstance())), page(this, view_0, true));
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      vgs(_this__u8e3s4) {
        return _this__u8e3s4.jbb(get_scrolling(_this__u8e3s4), page(this, _this__u8e3s4, false));
      }
    }
    protoOf($).ud6 = render;
    initMetadataForClass($, 'LineItemCompletionForm', VOID, VOID, [DialogOrPage(), HasFallback()], [0]);
    LineItemCompletionFormClass = $;
  }
  return LineItemCompletionFormClass;
}
//region block: init
Companion_instance_1 = new (Companion())();
//endregion
//region block: exports
export {
  ScopeSetInfo as ScopeSetInfo20wjokolfm84l,
  Companion_instance_1 as Companion_instance3euo5q27joywz,
};
//endregion

//# sourceMappingURL=LineItemCompletionForm.mjs.map
